import React, { useState, useEffect, useRef, useMemo } from "react";
import { Row, Button, Col, Checkbox, Card, Input, Space, Divider, Typography, Modal, Radio, Select, Drawer, Switch, Badge, Skeleton, Tooltip, message } from "antd";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  CloseOutlined,
  TeamOutlined,
  LoadingOutlined,
  StopOutlined,
  SearchOutlined,
  PlusOutlined,
  MinusOutlined,
  CloseSquareFilled,
  CarOutlined,
  ReloadOutlined,
  GiftOutlined,
  CompassFilled,
  StarOutlined,
} from "@ant-design/icons";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import defaultImage from "../../../assets/images/no-image.svg";
import Back from "../../../assets/images/backIcon.svg";
import data from "../../../constants/restaurantPos.json";
import removeBg from "../../../assets/images/removebg.png";
import PlusIcon from "../../../assets/images/plusIconRestaurant.svg";
import minusIcon from "../../../assets/images/minusIconRestaurant.svg";
import DeleteProduct from "../../../assets/images/delete1.svg";
import addNote from "../../../assets/images/addNote.svg";
import DecrementImg from "../../../assets/images/Decrement2.svg";
import IncrementImg from "../../../assets/images/Increment2.svg";
import userIcon from "../../../assets/images/userId.svg";
import Close from "../../../assets/images/close-x.svg";
import DiscountIcon from "../../../assets/images/discountperIcon.svg";
import printBill from "../../../assets/images/printbillIcon.svg";
import Offers from "../../../assets/images/promoTag.svg";
import MoreOptionsIcon from "../../../assets/images/moreOptionsIcon.svg";
import DefaultProductImage from "../../../assets/images/no-image.svg";
import OrderListComponent from "./OrderListComponent";
import { v4 as uuidv4 } from "uuid";
import "./restaurantStyle.css";
import moment from "moment";
import db from "../../../database";
import _ from "lodash";
import Keyboard from "react-simple-keyboard";
import TextArea from "antd/lib/input/TextArea";
import PointOfSaleRetailModals from "../Retail/RetailModals";
import { useTranslation } from "react-i18next";
import { getMultilingualText } from "../../../utility/getMultilingualText ";
import { useEventBus } from "../../../lib/hooks/EventBusProvider";
import printController from "../../../lib/printer/printController";
import { numberToWords } from "../../../utility/numberToWords";
import FilterIcon from "../../../assets/images/filterNewICon.svg";
import vegIcon from "../../../assets/images/veg.png";
import eggIcon from "../../../assets/images/egg.png";
import { getWorkflowData } from "../../../utility/getWorkflowData";
const { Option } = Select;
const MenuLayout = (props) => {
  const {
    paymentModalInputRef,
    tillAccessData,
    setSelectedProductInCart,
    selectedProductId,
    setSelectedProductId,
    manualDiscountRestaurant,
    selectedSaleType,
    setSelectedSaleType,
    cart,
    restaurantProductCategory,
    productsData,
    pickProduct,
    decreaseProductQty,
    deleteProduct,
    increaseProductQty,
    handleOrder,
    handleVoid,
    addDefinedProductWithAddons,
    addProductWithAddons,
    setKeyValue,
    paymentVisible,
    setPaymentVisible,
    userPreferences,
    setDisplayCustomerSearch,
    categorieFlag,
    setCategorieFlag,
    setCart,
    showProducts,
    setShowProducts,
    setProductsData,
    saleTypeProducts,
    setSaleTypeProducts,
    requestPayment,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    amount,
    setAmount,
    showOrderCompleteFlag,
    setShowOrderCompleteFlag,
    processOrder,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    handleAmount,
    handleCashPayment,
    showSplitBill,
    setShowSplitBill,
    splitBillScreen,
    setSplitBillScreen,
    numSplits,
    setNumSplits,
    showAllItems,
    setShowAllItems,
    splitCarts,
    setSplitCarts,
    saleType,
    selectedTable,
    isSplitBill,
    setIsSplitBill,
    currentSplitIndex,
    setCurrentSplitIndex,
    recordState,
    setRecardState,
    documentSequence,
    setDocumnetSequence,
    clearCart,
    removeSplit,
    setRemoveSplit,
    mainTableData,
    setMainTableData,
    clearProductSearchResults,
    // Keyboard,
    setOpen,
    setInputName,
    keyboard,
    handleSelectProduct,
    selectedProductInCart,
    selectedProducts,
    setSelectedproducts,
    showSendToKitchen,
    setShowSendToKitchen,
    setSearchhistoryInput,
    searchHistoryInput,
  } = props;
  const { t } = useTranslation();
  const { Text, Title } = Typography;
  const [productCategoriesList, setProductCategoriesList] = useState([]);
  const [productSearchInput, setProductSearchInput] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemNotes, setSelectedItemNotes] = useState("");
  const [notesValue, setNotesValue] = useState("");
  const [notesPopup, setNotesPopup] = useState(false);
  const [categorieName, setCategorieName] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [layoutName, setLayoutName] = useState("default");
  const [instructions, setInstructions] = useState(notesValue);
  // const [selectedProduct, setSelectedProduct] = useState(null);
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const tillaccess = JSON.parse(tillData.tillAccess.userAccessController);
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const showImage = posConfig?.showImage === "Y";
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  // Add ONS Modal Starts //
  const [categoryLookup, setCategoryLookup] = useState({});
  const [groupedProducts, setGroupedProducts] = useState([]);
  const [displayAddOnSelection, setDisplayAddOnSelection] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [addOnsList, setAddOnsList] = useState({
    requiredList: [],
    optionsList: [],
  });
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { dispatchEvent } = useEventBus();
  const [isAllParkedState, setIsAllParkedState] = useState(false);
  const [additionalCharges, setAdditionalCharges] = useState(false);
  const [serviceChargeEnabled, setServiceChargeEnabled] = useState(false);
  const [serviceChargePercentage, setServiceChargePercentage] = useState(5);
  const [tipMode, setTipMode] = useState("Percentage");
  const [tipPercentage, setTipPercentage] = useState(0);
  const [tipAmount, setTipAmount] = useState(0);
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [packingCharge, setPackingCharge] = useState(0);
  const [roundingOption, setRoundingOption] = useState("No Rounding");
  const [categorySearch, setCategorySearch] = useState("");
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [selectCategotyList, setSelectCategotyList] = useState([]);
  const [loading, setLoading] = useState(false); // Optional, for loading state
  const productPanelSearchRef = useRef(null);
  const [defaultCategorySet, setDefaultCategorySet] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  //const [showSendToKitchen, setShowSendToKitchen] = useState(false);

  const toFixedTruncate = (num, decimalPlaces = 3) => {
    if (isNaN(num) || num === null) num = 0;
    const factor = Math.pow(10, decimalPlaces);
    const truncatedNum = Math.trunc(num * factor) / factor;
    const result = truncatedNum.toFixed(decimalPlaces);
    return result;
  };

  const guestName = JSON.parse(localStorage.getItem("tableName"))?.guestName;
  const isGuestPresent = !!guestName;

  const categoryCounts = useMemo(() => {
    return saleTypeProducts.reduce((acc, product) => {
      const categoryId = product.mProductCategoryId || "uncategorized";
      acc[categoryId] = (acc[categoryId] || 0) + 1;
      return acc;
    }, {});
  }, [saleTypeProducts]);

  const handleCategoryClick = async (categoryId, categoryName) => {
    setLoading(true);
    setSelectedCategory(categoryId);
    setCategorieName(categoryName);

    try {
      // Assuming restaurantProductCategory fetches and updates productsData
      await restaurantProductCategory(categoryId);
      setProductSearchInput("");
      let filteredProducts = [];

      if (productSearchInput.trim().length > 0) {
        const searchInput = productSearchInput.toLowerCase();
        filteredProducts = saleTypeProducts.filter((product) => {
          const matchesName = product.name?.toLowerCase().includes(searchInput);
          const matchesValue = product.value?.toLowerCase().includes(searchInput);
          const matchesUPC = product.upc?.toLowerCase().includes(searchInput);

          return product.mProductCategoryId === categoryId && (matchesName || matchesValue || matchesUPC) && product.isBestSeller;
        });
      } else {
        // No search → show all bestsellers in this category
        filteredProducts = saleTypeProducts.filter((product) => product.mProductCategoryId === categoryId && product.isBestSeller);
      }

      setProductsData(filteredProducts);
    } catch (error) {
      console.error("Error in restaurantProductCategory:", error);
    }

    setCategorieFlag(true);
    // ❌ don’t reset productSearchInput here
    setLoading(false);
  };

  const getFoodTypeIcon = (foodType) => {
    if (!foodType) return null; // if empty, don't show anything
    if (foodType === "VEG") return vegIcon;
    if (foodType === "NVG") return removeBg;
    if (foodType === "EGG") return eggIcon;
    return null;
  };

  const bestsellerCategories = useMemo(
    () => productCategoriesList.filter((category) => saleTypeProducts.some((product) => product.mProductCategoryId === category.mProductCategoryId && product.isBestSeller)),
    [productCategoriesList, saleTypeProducts]
  );

  const pastelColors = ["#F8C8DC", "#FFD1D1", "#FFE5B4", "#FFF4C1", "#D4F4DD", "#C8E6F5", "#D1E8FF", "#E6E6FA", "#F0D4F0", "#FFE4E1", "#E0F7FA", "#F5F5DC"];

  const getColorFromId = (id) => {
    const hash = id.split("").reduce((a, b) => a + b.charCodeAt(0), 0);
    return pastelColors[hash % pastelColors.length];
  };

  useEffect(() => {
    if (filterDrawer && productCategoriesList.length > 0) {
      // pick the first category (sorted alphabetically if you want)
      const sortedCategories = [...productCategoriesList].sort((a, b) => a.name.localeCompare(b.name));
      const firstCategory = sortedCategories[0];

      if (firstCategory) {
        setSelectCategotyList([firstCategory.mProductCategoryId]);
        setCategorieName(firstCategory.name);
        setSelectedCategory(firstCategory.mProductCategoryId);

        // fetch and set products for this category
        restaurantProductCategory(firstCategory.mProductCategoryId);
        setCategorieFlag(true);
      }
    }
  }, [filterDrawer, productCategoriesList]);

  useEffect(() => {
    if (productSearchInput.length > 0) {
      const searchedProducts = saleTypeProducts.filter((product) => {
        const searchInput = productSearchInput.toLowerCase();
        const matchesName = product.name?.toLowerCase().includes(searchInput);
        const matchesValue = product.value?.toLowerCase().includes(searchInput);
        const matchesUPC = product.upc?.toLowerCase().includes(searchInput);
        return matchesName || matchesValue || matchesUPC;
      });

      if (searchedProducts.length > 0) {
        setSelectedCategory(searchedProducts[0].mProductCategoryId);
      }
    }
  }, [productSearchInput, saleTypeProducts]);

  useEffect(() => {
    if (!defaultCategorySet && productCategoriesList.length > 0 && saleTypeProducts.length > 0 && bestsellerCategories.length > 0) {
      const sortedCategories = [...bestsellerCategories].sort((a, b) => a.name.localeCompare(b.name));
      if (sortedCategories[0]) {
        setSelectedCategory(sortedCategories[0].mProductCategoryId);
        setDefaultCategorySet(true);
      }
      if (bestsellerCategories.length > 0 && !selectedCategory) {
        setSelectedCategory(bestsellerCategories[0].mProductCategoryId);
      }
    }
  }, [bestsellerCategories, productCategoriesList, saleTypeProducts, defaultCategorySet]);

  // const ProductTile = ({ product }) => (
  //     <Card
  //                     key={product.mProductId}
  //                     style={{
  //                       borderRadius: "8px",
  //                       border: "1px solid #e8e8e8",
  //                       cursor: "pointer",
  //                       position: "relative",
  //                       padding: "12px",
  //                       overflow: "visible",
  //                     }}
  //                     onClick={product?.productAddons?.length > 0 ? (e) => handleAddOnModal(product, e) : () => pickProduct(product)}
  //                   >
  //                     <div
  //                       style={{
  //                         height: "60px",
  //                         background: "#f5f5f5",
  //                         borderRadius: "6px",
  //                         display: "flex",
  //                         alignItems: "center",
  //                         justifyContent: "center",
  //                         marginBottom: "8px",
  //                         overflow: "visible",
  //                         position: "relative",
  //                       }}
  //                     >
  //                       <img
  //                         src={product.imageurl || DefaultProductImage}
  //                         alt={product.name}
  //                         style={{
  //                           width: product.imageurl ? "100%" : "40px",
  //                           height: product.imageurl ? "100%" : "40px",
  //                           objectFit: product.imageurl ? "cover" : "contain",
  //                           margin: product.imageurl ? "0" : "auto",
  //                         }}
  //                       />
  //                       {product.isBestSeller && (
  //                         <div
  //                           style={{
  //                             position: "absolute",
  //                             top: "4px",
  //                             right: "4px",
  //                             backgroundColor: "#eab308",
  //                             padding: "2px 6px",
  //                             display: "flex",
  //                             alignItems: "center",
  //                             borderRadius: "10px",
  //                             fontSize: "10px",
  //                             fontWeight: 500,
  //                             zIndex: 1,
  //                           }}
  //                         >
  //                           <StarOutlined style={{ fontSize: "10px", marginRight: "4px" }} />
  //                           Best
  //                         </div>
  //                       )}
  //                     </div>
  //                     <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
  //                       <h3
  //                         style={{
  //                           fontSize: "0.8em",
  //                           fontWeight: "600",
  //                           color: "#0F0718",
  //                           overflow: "hidden",
  //                           textOverflow: "ellipsis",
  //                           display: "-webkit-box",
  //                           WebkitLineClamp: 2,
  //                           WebkitBoxOrient: "vertical",
  //                         }}
  //                       >
  //                         {product.name}
  //                       </h3>
  //                       <div style={{ fontSize: "0.8rem", color: "#4b5563", marginBottom: "0.25rem" }}>
  //                         <span style={{ fontWeight: "500" }}>{product.value}</span>
  //                       </div>
  //                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //                         <span style={{ fontSize: "0.9em", fontWeight: "700", color: "#389e0d" }}>
  //                           {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
  //                           {product.sunitprice.toFixed(2)}
  //                           {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}/{product.uomName}
  //                         </span>
  //                                     <Col
  //                                       span={2}
  //                                       style={{
  //                                         display: "flex",
  //                                         alignItems: "center",
  //                                         justifyContent: "center",
  //                                         marginLeft: "2px",
  //                                       }}
  //                                     >
  //                                       {getFoodTypeIcon(product.foodType) && (
  //                                         <img
  //                                           src={getFoodTypeIcon(product.foodType)}
  //                                           style={{ height: "1.8vh" }}
  //                                         />
  //                                       )}
  //                                     </Col>
  //                       </div>
  //                     </div>
  //     </Card>
  // );

  const frequentProducts = productsData.filter((item) => item.isBestSeller);
  const nonfrequentProducts = productsData.filter((item) => !item.isBestSeller);

  const applySearchFilter = (searchValue, categoryIds) => {
    const value = searchValue.toLowerCase().trim();

    if (!value) {
      // Only category filter
      if (categoryIds.length === 0) return saleTypeProducts;
      return saleTypeProducts.filter((product) => categoryIds.includes(product.mProductCategoryId));
    }

    return saleTypeProducts.filter((product) => {
      const matchesText = product.name.toLowerCase().includes(value) || product.value?.toLowerCase().includes(value) || product.code?.toLowerCase().includes(value);

      const matchesCategory = categoryIds.length === 0 || categoryIds.includes(product.mProductCategoryId);

      return matchesText && matchesCategory;
    });
  };

  const applyRounding = (value, precision = pricePrecision) => {
    if (isNaN(value) || value === null) return 0;
    const factor = Math.pow(10, precision);
    switch (roundingOption) {
      case "Round Up":
        return Math.ceil(value * factor) / factor;
      case "Round Down":
        return Math.floor(value * factor) / factor;
      case "No Rounding":
      default:
        return parseFloat(toFixedTruncate(value, precision));
    }
  };

  const subtotal = cart?.subTotal || 0;
  const serviceChargeAmount = applyRounding(serviceChargeEnabled ? (subtotal * serviceChargePercentage) / 100 : 0);
  const tipTotal = applyRounding(tipMode === "Percentage" && tipPercentage > 0 ? (subtotal * tipPercentage) / 100 : tipAmount);
  const deliveryChargeAmount = applyRounding(deliveryCharge);
  const packingChargeAmount = applyRounding(packingCharge);
  const AdditionalChargesTotal = serviceChargeAmount + tipTotal + deliveryChargeAmount + packingChargeAmount;

  useEffect(() => {
    const allParked = cart.items.length > 0 && cart.items.every((item) => item.parkedItem === true);
    const hasUnparkedItems = cart.items.some((item) => item.parkedItem !== true);
    const sameProductQtyIncreased = cart.items.some((item) => item.productId === selectedProductInCart?.productId);
    const hasPendingToSend = cart.items.some((item) => item.sendQty > 0);
    if (hasUnparkedItems || hasPendingToSend) {
      setShowSendToKitchen(true);
      setIsAllParkedState(false);
    } else {
      setShowSendToKitchen(false);
      setIsAllParkedState(allParked);
    }
  }, [cart.items, selectedProductInCart]);

  useEffect(() => {
    const matchedProduct = cart.items.find((item) => item.productId === selectedProductInCart?.productId);
    setSelectedproducts((prev) => [...prev, matchedProduct]);
  }, [selectedProductInCart]);

  useEffect(() => {
    setProductSearchInput("");
    setCategorieFlag(false);
  }, []);

  const handleShift = () => {
    layoutName === "default" ? setLayoutName("shift") : setLayoutName("default");
  };

  const handleAdditionalCharges = async () => {
    setAdditionalCharges(true);
  };

  const handleApplyCharges = () => {
    setAdditionalCharges(false);
    const localCart = JSON.parse(localStorage.getItem("cartObj"));
    if (localCart) {
      // const updatedTotal = parseFloat(localCart.total || 0) + parseFloat(AdditionalChargesTotal || 0);
      // localCart.total = updatedTotal;
      localCart.serviceCharge = serviceChargeAmount;
      localCart.tip = tipTotal;
      localCart.deiveryCharge = deliveryChargeAmount;
      localCart.packingCharge = packingChargeAmount;
      localStorage.setItem("cartObj", JSON.stringify(localCart));
      setCart(localCart);
    }
  };

  const resetToInitialState = () => {
    setServiceChargeEnabled(false);
    setServiceChargePercentage(5);
    setTipMode("Percentage");
    setTipPercentage(0);
    setTipAmount(0);
    setDeliveryCharge(0);
    setPackingCharge(0);
    setRoundingOption("No Rounding");
    const localCart = JSON.parse(localStorage.getItem("cartObj"));
    if (localCart) {
      // const updatedTotal = parseFloat(localCart.total || 0) - parseFloat(AdditionalChargesTotal || 0);
      // localCart.total = updatedTotal;
      localCart.serviceCharge = 0;
      localCart.tip = 0;
      localCart.deiveryCharge = 0;
      localCart.packingCharge = 0;
      localStorage.setItem("cartObj", JSON.stringify(localCart));
      setCart(localCart);
    }
  };

  const handleAddOnModal = (record, event) => {
    event.stopPropagation();
    setDisplayAddOnSelection(true);
    setSelectedProduct(record);

    const requiredListFilter = _.filter(record.productAddons, (item) => item.mAddonGroup.minqty === 1);
    const optionsListFilter = _.filter(record.productAddons, (item) => item.mAddonGroup.minqty === 0);
    setAddOnsList({
      requiredList: requiredListFilter,
      optionsList: optionsListFilter,
    });
  };

  const handleAddOnValue = (e, fieldName) => {
    let newSelectedAddons = [...selectedAddons];
    const indexValue =
      fieldName === "addOnRadio"
        ? _.findIndex(newSelectedAddons, (item) => item.mAddonGroup.mAddonGroupId === e.target.value.mAddonGroup.mAddonGroupId)
        : _.findIndex(newSelectedAddons, (item) => item === e.target.value);
    if (indexValue !== -1) {
      if (e.target.checked) {
        newSelectedAddons[indexValue] = e.target.value;
      } else {
        newSelectedAddons.splice(indexValue, 1);
      }
    } else {
      newSelectedAddons = [...selectedAddons, e.target.value];
    }
    setSelectedAddons(newSelectedAddons);
  };

  const handleQty = (fieldName) => {
    let newSelectedProduct = {
      ...selectedProduct,
      weight: selectedProduct?.weight || 1,
    };
    if (fieldName === "plus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) + 1;
    }
    if (fieldName === "minus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) - 1;
      if (newSelectedProduct.weight <= 1) {
        newSelectedProduct.weight = 1;
      }
    }

    setSelectedProduct({
      ...newSelectedProduct,
    });
  };

  const handleAdd = async () => {
    await addDefinedProductWithAddons(
      {
        ...selectedProduct,
        sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
        // productAddons: selectedAddons || [],
        selectedAddons: selectedAddons || [],
        weight: selectedProduct?.weight || 1,
      },
      selectedProduct.upc,
      null,
      null,
      selectedProduct.sunitprice
    );
    handleAddOnModalClose();
  };

  const handleAddOnModalClose = () => {
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
  };

  useEffect(() => {
    db.productCategories
      .toArray()
      .then((response) => {
        const result = response.filter((item) => {
          const filteredProducts = saleTypeProducts?.filter((product) => product?.mProductCategoryId === item?.mProductCategoryId);
          if (filteredProducts?.length > 0) {
            return item;
          }
        });
        setProductCategoriesList(result);
      })
      .catch((error) => {
        // Handle any errors that occur
        console.error(error);
      });
  }, [saleTypeProducts]);

  const showProductModal = (product) => {
    setSelectedProduct(product);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setSelectedProduct(null);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedProduct(null);
  };

  const filteredProducts = productsData.filter((product) => product.isBestSeller && product.mProductCategoryId === selectedCategory);

  useEffect(() => {
    if (productCategoriesList?.length > 0 && !filterDrawer) {
      const filtered = productCategoriesList
        .filter((category) => saleTypeProducts.some((product) => product.mProductCategoryId === category.mProductCategoryId && product.isBestSeller))
        .sort((a, b) => a.name.localeCompare(b.name));

      if (filtered.length > 0) {
        // Case 1: Best sellers available
        const firstCategory = filtered[0];
        setSelectedCategory(firstCategory.mProductCategoryId);
        setCategorieName(firstCategory.name);
        restaurantProductCategory(firstCategory.mProductCategoryId);

        setSaleTypeProducts((prev) => {
          const filteredProducts = prev.filter((product) => product.mProductCategoryId === firstCategory.mProductCategoryId && product.isBestSeller);
          setProductsData(filteredProducts);
          return prev;
        });
      } else {
        // Case 2: No best sellers -> show ALL categories & products
        const sortedCategories = [...productCategoriesList].sort((a, b) => a.name.localeCompare(b.name));

        if (sortedCategories.length > 0) {
          const firstCategory = sortedCategories[0];
          setSelectedCategory(firstCategory.mProductCategoryId);
          setCategorieName(firstCategory.name);
          restaurantProductCategory(firstCategory.mProductCategoryId);

          setSaleTypeProducts((prev) => {
            const filteredProducts = prev.filter((product) => product.mProductCategoryId === firstCategory.mProductCategoryId);
            setProductsData(filteredProducts);
            return prev;
          });
        } else {
          // absolutely no categories
          setSelectedCategory(null);
          setCategorieName("");
          setProductsData([]);
        }
      }
    }
  }, [productCategoriesList, saleTypeProducts, filterDrawer]);

  useEffect(() => {
    if (productCategoriesList?.length > 0) {
      const defaultCategory = productCategoriesList[0];
      const filteredProducts = saleTypeProducts.filter((product) => product.mProductCategoryId === defaultCategory.mProductCategoryId);
      setProductsData(filteredProducts);
    } else {
      setProductsData([]);
    }
  }, [saleTypeProducts, productCategoriesList]);

  const cartItems = cart.items;
  // const cartItems = JSON.parse(localStorage.getItem("cartObj").items);
  // const cartObj = JSON.parse(localStorage.getItem("cartObj"));
  // const cartItems = cartObj ? cartObj.items : null;

  useEffect(() => {
    db.productCategories
      .toArray()
      .then((response) => {
        const lookup = response.reduce((acc, category) => {
          acc[category.mProductCategoryId.trim()] = category.name.trim();
          return acc;
        }, {});
        setCategoryLookup(lookup);
      })
      .catch((error) => {
        console.error("Error fetching product categories:", error);
      });
    const groupedProducts = cartItems?.reduce((acc, item) => {
      const categoryName = categoryLookup[item.mProductCategoryId.trim()] || "";
      if (!acc[categoryName]) {
        acc[categoryName] = [];
      }
      acc[categoryName].push(item);
      return acc;
    }, {});

    setGroupedProducts(groupedProducts);
  }, [cartItems]);
  // console.log("groupedProducts outside useEffect:", groupedProducts);
  return (
    <>
      {paymentVisible ? (
        <OrderListComponent
          {...props}
          requestPayment={requestPayment}
          recordState={recordState}
          setRecardState={setRecardState}
          setSearchhistoryInput={setSearchhistoryInput}
          searchHistoryInput={searchHistoryInput}
        />
      ) : splitBillScreen ? (
        <div style={{ padding: "10px 0px 10px 15px", fontSize: "1vw", overflow: "hidden" }}>
          <Row style={{ display: "flex", alignItems: "center" }}>
            <img
              src={Back}
              style={{
                height: "4vh",
                cursor: "pointer",
                paddingBottom: "0.1em",
              }}
              onClick={() => {
                setSplitBillScreen(false);
                setNumSplits(2);
                setIsSplitBill(false);
                setSplitCarts([]);
                setCurrentSplitIndex(0);
                setShowAllItems(true);
              }}
            />
            <p style={{ marginBottom: 0, paddingLeft: "4px", color: "#0F0718", fontSize: "1.5em", fontWeight: 500 }}>Split Bill</p>
          </Row>
          <Row style={{ marginTop: "2vh" }}>
            {showAllItems ? (
              <Col span={6} style={{ border: "1px solid #ccc", height: "83vh", borderRadius: "7px", backgroundColor: "#fff" }}>
                <p style={{ marginBottom: 0, fontSize: "1.25em", fontWeight: 500, color: "#0F0718", textAlign: "center", padding: "10px 10px 0 10px" }}>All Items</p>

                <Scrollbars autoHide style={{ height: "75vh" }}>
                  <div style={{ padding: "0px 15px 10px 15px" }}>
                    {cart?.items?.map((item, index) => (
                      <Row
                        key={index}
                        style={{
                          border: "1px solid #ccc",
                          // height: "22vh",
                          height: "auto",
                          borderRadius: "5px",
                          marginTop: "1vh",
                          padding: "10px",
                        }}
                      >
                        <Col span={18} style={{ fontSize: "1em", fontWeight: 500, color: "#0F0718", height: "5vh" }}>
                          {item?.name}
                        </Col>
                        <Col span={6} style={{ fontSize: "1em", fontWeight: 500, color: "#0F0718", textAlign: "right", height: "5vh" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {item?.nettotal}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                        </Col>
                        <Col span={24} style={{ marginTop: 0 }}>
                          <p style={{ marginBottom: 0, color: "#929098", fontSize: "1em", fontWeight: 500 }}>Quantity: {item?.weight}</p>
                          <p style={{ marginBottom: 0, color: "#0F0718", fontSize: "1em", fontWeight: 500, marginTop: "1vh" }}>Assign to:</p>

                          <div div style={{ display: "flex", flexWrap: "wrap", gap: "0.5em", marginTop: "0.8vh" }}>
                            {[...Array(numSplits)].map((_, i) => (
                              <button
                                key={i}
                                style={{
                                  // background: "#0F0718",
                                  backgroundColor: "#2F3856",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: "20px",
                                  padding: "2px 12px",
                                  fontSize: "0.85em",
                                  cursor: "pointer",
                                }}
                              >
                                Split {i + 1}
                              </button>
                            ))}
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </div>
                </Scrollbars>
              </Col>
            ) : null}

            <Col span={18} style={{ padding: "0 15px" }}>
              <Row gutter={[8, 8]}>
                {/* {[...Array(numSplits)].map((_, splitIndex) => {
                  const splitCart = splitCarts[splitIndex] || {}; */}
                {splitCarts.map((splitCart, splitIndex) => {
                  return (
                    <Col span={8} key={splitIndex}>
                      <div
                        style={{
                          background: "#fff",
                          height: "83vh",
                          width: "100%",
                          position: "relative",
                          fontSize: "1vw",
                          borderRadius: "5px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "2vh 1vw 0 1vw",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: 600,
                              fontSize: "1.5em",
                              color: "#0F0718",
                              fontFamily: "Inter",
                            }}
                          >
                            {getMultilingualText("Order Details")}
                          </span>
                          <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>{moment(splitCart.orderTime).format(userPreferences.dateFormat)}</span>
                        </div>

                        {/* {saleType === "DI" && (
                          <p
                            style={{
                              padding: "0 1vw",
                              fontSize: "1em",
                              color: "#0F0718",
                              fontWeight: 500,
                              marginBottom: "5px",
                            }}
                          >
                            {selectedTable?.name}
                          </p>
                        )}

                        <span>Split {splitCart.splitNo}</span> */}

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0.5vh 1vw 0 1vw",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "0.9em",
                              color: "#0F0718",
                              fontWeight: 500,
                            }}
                          >
                            {/* {selectedTable?.name} */}
                            {localStorage.getItem("dineIn") === "Y" && splitCart?.tableNo && splitCart.tableNo} {splitCart?.documentno}
                            {/* {splitCart?.tableNo} {splitCart?.documentno} */}
                          </span>
                          <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>Split {splitCart.splitNo}</span>
                        </div>

                        <hr style={{ color: "#929098", width: "93%" }} />

                        <Scrollbars
                          autoHide
                          style={{
                            height: !showAllItems ? "41vh" : "50vh",
                          }}
                        >
                          <InfiniteScroll
                            dataLength={splitCart.items?.length || 0}
                            hasMore={true}
                            endMessage={
                              <p className="center">
                                <b>Yay! you have seen it all</b>
                              </p>
                            }
                            style={{ overflowX: "hidden" }}
                          >
                            {splitCart.items?.map((item) => (
                              <div key={item.lineId} style={{ padding: "12px" }}>
                                <div
                                  style={{
                                    fontSize: "1vw",
                                    backgroundColor: selectedProductId === item.lineId ? "#f0f0f0" : "transparent",
                                  }}
                                >
                                  <Row>
                                    <Col span={5}>
                                      <img
                                        src={item.imageurl || defaultImage}
                                        alt={item.name}
                                        style={{
                                          height: item.description ? "10vh" : "8vh",
                                          width: "4vw",
                                          objectFit: "cover",
                                          borderRadius: "7px",
                                        }}
                                      />
                                    </Col>
                                    <Col span={16} style={{ display: "flex", flexDirection: "column", paddingLeft: "0.5vw" }}>
                                      <Text style={{ fontSize: "0.8em", color: "#0F0718", fontWeight: 500 }}>{item.name}</Text>
                                      <Text style={{ fontSize: "0.5em", color: "#929098", fontWeight: 400 }}>{item.description}</Text>
                                      <Text style={{ fontWeight: 600, fontSize: "1em", color: "#0F0718" }}>
                                        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                        {/* {item.nettotal.toFixed(item?.isQtyDesimal)} */}
                                        {toFixedTruncate(item.nettotal, item?.isQtyDesimal)}
                                        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                      </Text>
                                    </Col>
                                    <Col
                                      span={2}
                                      style={{
                                        textAlign: "center",
                                        color: "#0F0718",
                                        fontWeight: 500,
                                        fontSize: "0.8em",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      X {item.weight}
                                    </Col>
                                    <span
                                      style={{
                                        background: Math.abs(item.discount) > 0 ? "#F8C519" : "",
                                        borderRadius: "3px",
                                        padding: "0.25vw",
                                        display: item.discountName ? "" : "none",
                                        fontSize: "0.7em",
                                        marginTop: "1vh",
                                      }}
                                    >
                                      {Math.abs(item.discount) > 0 && item.discountName && (
                                        <>
                                          <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} /> {item.discountName}
                                        </>
                                      )}
                                    </span>
                                  </Row>
                                </div>
                              </div>
                            ))}
                          </InfiniteScroll>
                        </Scrollbars>

                        <div
                          style={{
                            padding: "1vh 0.6vw",
                            position: "absolute",
                            bottom: "1vh",
                            width: "100%",
                          }}
                        >
                          <Scrollbars autoHide style={{ height: "18vh" }}>
                            <Space
                              direction="vertical"
                              style={{
                                width: "100%",
                                background: "#F3F4F9",
                                padding: "1vh 0.5vw",
                                borderRadius: "10px",
                                rowGap: "4px",
                              }}
                            >
                              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Subtotal")}</Text>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {/* {(splitCart?.total - splitCart?.tax).toFixed(2)} */}
                                  {toFixedTruncate(splitCart?.total - splitCart?.tax, pricePrecision)}
                                  {/* {toFixedTruncate(splitCart?.subTotal, pricePrecision)} */}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                </Text>
                              </Space>

                              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Discount Sales")}</Text>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {/* {parseFloat(splitCart?.discount || 0).toFixed(2)} */}
                                  {toFixedTruncate(splitCart?.discount || 0, pricePrecision)}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                </Text>
                              </Space>

                              <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Total Sales Tax")}</Text>
                                <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {/* {parseFloat(splitCart.tax).toFixed(2)} */}
                                  {toFixedTruncate(splitCart.tax, pricePrecision)}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                </Text>
                              </Space>

                              {serviceChargeAmount > 0 && (
                                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Service Charge")}</Text>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {toFixedTruncate(Math.floor(parseFloat(splitCart.serviceCharge || 0) * 100) / 100, pricePrecision)}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                  </Text>
                                </Space>
                              )}
                              {tipTotal > 0 && (
                                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Tip")}</Text>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {toFixedTruncate(Math.floor(parseFloat(splitCart.tip || 0) * 100) / 100, pricePrecision)}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                  </Text>
                                </Space>
                              )}
                              {deliveryCharge > 0 && (
                                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Delivery Charge")}</Text>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {toFixedTruncate(Math.floor(parseFloat(splitCart.deiveryCharge || 0) * 100) / 100, pricePrecision)}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                  </Text>
                                </Space>
                              )}
                              {packingCharge > 0 && (
                                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Packing Charge")}</Text>
                                  <Text style={{ fontSize: "0.8em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {toFixedTruncate(Math.floor(parseFloat(splitCart.packingCharge || 0) * 100) / 100, pricePrecision)}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                  </Text>
                                </Space>
                              )}

                              <Space style={{ width: "100%", justifyContent: "space-between", marginTop: "2px" }}>
                                <Text style={{ fontSize: "1em", fontWeight: 600, color: "#0F0718", fontFamily: "Inter" }}>{getMultilingualText("Total Amount")}</Text>
                                <Text style={{ fontSize: "1em", fontWeight: 600, color: "#0F0718", fontFamily: "Inter" }}>
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {toFixedTruncate(
                                    Math.floor(parseFloat(splitCart.total + splitCart.deiveryCharge + splitCart.packingCharge + splitCart.tip + splitCart.serviceCharge) * 100) /
                                      100,
                                    pricePrecision
                                  )}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                </Text>
                              </Space>
                            </Space>
                          </Scrollbars>
                          {!showAllItems && (
                            <div>
                              <Space direction="horizontal" style={{ paddingTop: "2vh" }}>
                                <Button
                                  onClick={() => {
                                    // setSplitBillScreen(false);
                                    setPaymentVisible(true);
                                    // setAmount((Math.floor(parseFloat(splitCart.total || 0) * 100) / 100).toFixed(2));
                                    setRemoveSplit(splitCart);
                                    setAmount(toFixedTruncate(Math.floor(parseFloat(splitCart.total || 0) * 100) / 100, pricePrecision));
                                    setCart(splitCart);

                                    localStorage.setItem("cartObj", JSON.stringify(splitCart));
                                    const tablename = JSON.parse(localStorage.getItem("tableName"));

                                    const newSplitCartData = {
                                      ...recordState,
                                      documentno: splitCart.documentno,
                                      items: splitCart.items,
                                      uniqueId: uuidv4().replace(/-/g, "").toUpperCase(),
                                    };
                                    localStorage.setItem("tableName", JSON.stringify(newSplitCartData));
                                  }}
                                  style={{
                                    width: "21vw",
                                    borderRadius: "10px",
                                    backgroundColor: "#2F3856",
                                    color: "#fff",
                                    height: "6vh",
                                    fontSize: "1em",
                                    fontWeight: 500,
                                  }}
                                >
                                  Pay Bill
                                </Button>
                              </Space>
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  );
                })}
                {/* })} */}
              </Row>
            </Col>
          </Row>
          {showAllItems ? (
            <Row style={{ marginTop: "1.3vh", display: "flex", justifyContent: "flex-end", padding: "0px 15px 0px 0px" }}>
              <Col span={4}>
                <Button
                  style={{
                    backgroundColor: "#2F3856",
                    color: "#fff",
                    fontSize: "1.2em",
                    borderRadius: "5px",
                    width: "100%",
                    height: "5.5vh",
                  }}
                  onClick={() => {
                    setShowAllItems(false);
                    const cartobj = JSON.parse(localStorage.getItem("cartObj"));
                    const tillDocumentSequence = parseFloat(localStorage.getItem("documentSequence"));
                    const newDocumentSequence = tillDocumentSequence;
                    localStorage.setItem("documentSequence", newDocumentSequence);
                    // setDocumnetSequence(newDocumentSequence);
                  }}
                >
                  Done
                </Button>
              </Col>
            </Row>
          ) : null}
        </div>
      ) : (
        <div style={{ display: "flex", overflow: "hidden" }}>
          <div style={{ width: cart.items.length > 0 ? "69%" : "100%", height: "100vh" }}>
            <Row style={{ padding: "2vh 1.5vw 0 1.5vw", fontSize: "1vw" }}>
              {/* <Col span={24}>
        <p style={{ fontWeight: 500, paddingLeft: "3px", fontSize: "1.25em", color: "#0F0718", paddingTop: "0.5em" }}>Order: {cart.documentno}</p>
       </Col> */}
              <Col span={24}>
                <p style={{ fontWeight: 500, paddingLeft: "3px", fontSize: "1.25em", color: "#0F0718", paddingTop: "0.5em" }}>
                  {showProducts ? (
                    <img
                      src={Back}
                      style={{ height: "4.5vh", cursor: "pointer" }}
                      onClick={() => {
                        setShowProducts(false);
                        setShowSendToKitchen(false);
                      }}
                    />
                  ) : null}{" "}
                  {/* {getMultilingualText("Order")}: {cart.documentno} */}
                  {posConfig?.disableOfflineBilling !== "Y" && (
                    <>
                      {getMultilingualText("Order")}: {JSON.parse(localStorage.getItem("cartObj"))?.documentno}
                    </>
                  )}
                </p>
              </Col>
              <Col span={17}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Input
                    placeholder={getMultilingualText("Search for products by code/name")}
                    id="sm-product-search"
                    onChange={(e) => {
                      setProductSearchInput(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "+" || e.key === "=") {
                        e.preventDefault();
                        e.stopPropagation();
                      }
                      if (e.key === "-" && e.target.selectionStart === 0) {
                        e.preventDefault();
                      }
                    }}
                    className="productSearch-sm"
                    style={{ borderRadius: "20px", padding: "0.8vh 0.8vw", borderColor: "#fff" }}
                    value={productSearchInput}
                    suffix={
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        {productSearchInput.length > 0 ? (
                          <CloseSquareFilled style={{ fontSize: "20px", color: "#2F3856", cursor: "pointer" }} onClick={() => setProductSearchInput("")} />
                        ) : null}
                      </div>
                    }
                    prefix={
                      <img
                        src={SearchIcon}
                        alt=""
                        onClick={() => {
                          // onBarcodeInput(productSearchInput, false);
                        }}
                      />
                    }
                  />
                  <Button
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "4.5%",
                      margin: "0 1vw 0 0.5vw",
                      borderRadius: "7px",
                      borderColor: "#fff",
                    }}
                    id="sm-product-drawer"
                    onClick={() => {
                      setFilterDrawer(true);
                      setTimeout(() => {
                        if (productPanelSearchRef.current) {
                          productPanelSearchRef.current.focus();
                        }
                      }, 100);
                    }}
                  >
                    <img src={FilterIcon} style={{ height: "2.7vh" }} />
                  </Button>
                </div>
              </Col>
            </Row>
            <div className="tables-container-category" style={{ display: "flex" }}>
              {/* Left side: Categories */}
              <div
                style={{
                  width: "18%",
                  background: "#fff",
                  borderRight: "1px solid #eee",
                  padding: "1vh 0.5vw",
                  height: "81vh",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Search bar for categories */}
                <Input
                  placeholder="Search by categories"
                  value={categorySearch}
                  onChange={(e) => setCategorySearch(e.target.value)}
                  style={{ marginBottom: "1vh", borderRadius: "6px" }}
                />

                {/* Category list */}
                <Scrollbars autoHide style={{ flex: 1 }}>
                  {(bestsellerCategories.length > 0 ? bestsellerCategories : productCategoriesList)
                    .filter((categorie) => categorie.name.toLowerCase().includes(categorySearch.toLowerCase()))
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((categorie) => {
                      const isSelected = selectedCategory === categorie.mProductCategoryId;
                      return (
                        <div
                          key={categorie.mProductCategoryId}
                          onClick={() => handleCategoryClick(categorie.mProductCategoryId, categorie.name)}
                          style={{
                            padding: "6px 10px",
                            cursor: loading ? "not-allowed" : "pointer",
                            background: isSelected ? "#F5F6FA" : "transparent",
                            color: isSelected ? "#000" : "#555",
                            fontWeight: isSelected ? "600" : "400",
                            borderLeft: isSelected ? "4px solid #2F3856" : "4px solid transparent",
                          }}
                        >
                          {categorie.name}
                        </div>
                      );
                    })}
                </Scrollbars>
              </div>

              {/* Right side: Products (UNCHANGED from your code) */}
              <div style={{ flex: 1 }}>
                <Scrollbars autoHide style={{ height: "81vh" }}>
                  <InfiniteScroll
                    dataLength={bestsellerCategories.length}
                    hasMore={true}
                    endMessage={
                      <p className="center">
                        <b>Yay! you have seen it all</b>
                      </p>
                    }
                    style={{ overflowX: "hidden" }}
                  >
                    {loading ? (
                      <p>Loading products...</p>
                    ) : (
                      <Row gutter={[10, 10]} style={{ marginLeft: "0.5vw" }}>
                        {(() => {
                          // === Determine which products to show ===
                          const productsToShow =
                            productSearchInput.length > 0
                              ? bestsellerCategories.length > 0
                                ? filteredProducts
                                : saleTypeProducts.filter((product) => {
                                    const searchInput = productSearchInput.toLowerCase();
                                    const matchesName = product.name?.toLowerCase().includes(searchInput);
                                    const matchesValue = product.value?.toLowerCase().includes(searchInput);
                                    const matchesUPC = product.upc?.toLowerCase().includes(searchInput);
                                    return matchesName || matchesValue || matchesUPC;
                                  })
                              : bestsellerCategories.length > 0 && filteredProducts.length > 0
                              ? filteredProducts
                              : saleTypeProducts.filter((product) => product.mProductCategoryId === selectedCategory);

                          // === Minimal Card (showImage = N) ===
                          const MinimalCard = ({ product }) => (
                            <Col span={cart.items.length > 0 ? 6 : 4} key={product.id}>
                              <Card
                                onClick={product?.productAddons?.length > 0 ? (e) => handleAddOnModal(product, e) : () => pickProduct(product)}
                                style={{
                                  height: "90px",
                                  borderRadius: "10px",
                                  border: "1px solid #e8e8e8",
                                  padding: "10px",
                                  cursor: "pointer",
                                  color: "#0F0718",
                                  fontWeight: "500",
                                  backgroundColor: getColorFromId(product.mProductId || product.id),
                                  overflow: "hidden",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  position: "relative",
                                }}
                              >
                                <p
                                  title={product.name}
                                  style={{
                                    fontWeight: 500,
                                    fontSize: "13px",
                                    margin: 0,
                                    lineHeight: "1.4",
                                    textAlign: "center",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "100%",
                                    padding: "0 4px",
                                  }}
                                >
                                  {product.name}
                                </p>

                                <p
                                  style={{
                                    color: "green",
                                    fontWeight: 500,
                                    fontSize: "12px",
                                    margin: 0,
                                    position: "absolute",
                                    bottom: "8px",
                                    right: "10px",
                                  }}
                                >
                                  {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                  {product.sunitprice.toFixed(2)}
                                  {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                                </p>
                              </Card>
                            </Col>
                          );

                          // === Rich Card (showImage = Y) ===
                          const RichCard = ({ product }) => (
                            <Col span={cart.items.length > 0 ? 6 : 4} key={product.id}>
                              <Card
                                onClick={product?.productAddons?.length > 0 ? (e) => handleAddOnModal(product, e) : () => pickProduct(product)}
                                style={{
                                  height: "28vh",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={product?.imageurl?.trim() || defaultImage}
                                  style={{
                                    height: "17vh",
                                    backgroundPosition: "center",
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    borderRadius: "10px",
                                    padding: "0.8vh 0.55vw",
                                    width: "100%",
                                  }}
                                />
                                <div
                                  style={{
                                    height: "7vh",
                                    paddingLeft: "0.8vw",
                                    fontWeight: 500,
                                    fontSize: "1vw",
                                    paddingRight: "0.8vw",
                                  }}
                                >
                                  <p
                                    title={product?.name}
                                    style={{
                                      margin: "0",
                                      fontSize: "1em",
                                      fontWeight: 500,
                                      color: "#0F0718",
                                      height: "6vh",
                                      display: "-webkit-box",
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      WebkitLineClamp: 2,
                                    }}
                                  >
                                    {product?.name}
                                  </p>
                                  <Row>
                                    <Col
                                      span={21}
                                      style={{
                                        fontSize: "1.25em",
                                        fontWeight: "600",
                                        color: "#0F0718",
                                      }}
                                    >
                                      {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                      {product?.sunitprice}
                                      {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                    </Col>
                                    <Col
                                      span={2}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginLeft: "2px",
                                      }}
                                    >
                                      {getFoodTypeIcon(product.foodType) && <img src={getFoodTypeIcon(product.foodType)} style={{ height: "1.8vh" }} />}
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            </Col>
                          );

                          // === Render cards based on showImage flag ===
                          return productsToShow.map((product) =>
                            showImage ? <RichCard key={product.id} product={product} /> : <MinimalCard key={product.id} product={product} />
                          );
                        })()}
                      </Row>
                    )}
                  </InfiniteScroll>
                </Scrollbars>
              </div>
            </div>
            {/* <div className="tables-container-category">
  <Scrollbars autoHide style={{ height: "76vh" }}>
    <InfiniteScroll
      dataLength={productCategoriesList.length}
      hasMore={true}
      endMessage={
        <p className="center">
          <b>Yay! you have seen it all</b>
        </p>
      }
      style={{ overflowX: "hidden" }}
    >
      <Row gutter={[16, 16]} style={{ marginTop: "1vh" }}>
        {productCategoriesList
          .filter((categorie) => (productSearchInput.length === 0 ? true : categorie.name.toLowerCase().includes(productSearchInput.toLowerCase())))
          .map((categorie) => (
            <Col
              key={categorie.mProductCategoryId}
              style={{ display: "flex", justifyContent: "center", paddingRight: 0 }}
            >
              <Card
                onClick={() => {
                  setSelectedCategory(categorie.mProductCategoryId);
                  setCategorieName(categorie.name);
                  restaurantProductCategory(categorie.mProductCategoryId);
                  setCategorieFlag(true);
                  setProductSearchInput("");
                }}
                style={{
                  background: selectedCategory === categorie.mProductCategoryId ? "#2F3856" : "#fff",
                  height: "6vh",
                  borderRadius: "25px",
                  fontSize: "1vw",
                  cursor: "pointer",
                  display: "inline-block",
                  padding: "0 1em",
                  whiteSpace: "nowrap",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    fontSize: "1.1em",
                    fontWeight: "500",
                    color: selectedCategory === categorie.mProductCategoryId ? "#fff" : "#929098",
                  }}
                >
                  {categorie.name}
                </span>
              </Card>
            </Col>
          ))}
      </Row>

      {productSearchInput.length > 0 ? (
        // Search results grouped by category
        Object.entries(
          saleTypeProducts
            .filter((product) => {
              const searchInput = productSearchInput.toLowerCase();
              const matchesName = product.name?.toLowerCase().includes(searchInput);
              const matchesValue = product.value?.toLowerCase().includes(searchInput);
              const matchesUPC = product.upc?.toLowerCase().includes(searchInput);
              return matchesName || matchesValue || matchesUPC;
            })
            .reduce((acc, product) => {
              const categoryId = product.mProductCategoryId.trim();
              const categoryName = categoryLookup[categoryId] || "Unknown Category";
              if (!acc[categoryName]) {
                acc[categoryName] = [];
              }
              acc[categoryName].push(product);
              return acc;
            }, {})
        ).map(([categoryName, products]) => (
          <div key={categoryName} style={{ marginTop: "3vh" }}>
            <Text style={{ fontSize: "1.2em", fontWeight: "500", color: "#0F0718", paddingLeft: "1.5vw" }}>{categoryName}</Text>
            <Row gutter={[16, 16]} style={{ marginTop: "1vh" }}>
              {products.map((product) => (
                <Col span={cart.items.length > 0 ? 6 : 4} key={product.id} onClick={() => {}}>
                  <Card
                    onClick={product?.productAddons?.length > 0 ? (e) => handleAddOnModal(product, e) : () => pickProduct(product)}
                    style={{
                      height: "28vh",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={product?.imageurl?.trim() || defaultImage}
                      style={{
                        height: "17vh",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        borderRadius: "10px",
                        padding: "0.8vh 0.55vw",
                        width: "100%",
                      }}
                    />
                    <div
                      style={{
                        height: "7vh",
                        paddingLeft: "0.8vw",
                        fontWeight: 500,
                        fontSize: "1vw",
                        paddingRight: "0.8vw",
                      }}
                    >
                      <p
                        style={{
                          margin: "0",
                          fontSize: "1em",
                          fontWeight: 500,
                          color: "#0F0718",
                          height: "6vh",
                        }}
                      >
                        {product?.name}
                      </p>
                      <Row>
                        <Col
                          span={21}
                          style={{
                            fontSize: "1.25em",
                            fontWeight: "600",
                            color: "#0F0718",
                          }}
                        >
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {product?.sunitprice}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                        </Col>
                        <Col
                          span={2}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "2px",
                          }}
                        >
                          <img src={removeBg} style={{ height: "1.8vh" }} />
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        ))
      ) : (
        // Non-search: Current category products
        <Row gutter={[16, 16]} style={{ marginTop: "3vh" }}>
          {productsData.map((product) => (
            <Col span={cart.items.length > 0 ? 6 : 4} key={product.id} onClick={() => {}}>
              <Card
                onClick={product?.productAddons?.length > 0 ? (e) => handleAddOnModal(product, e) : () => pickProduct(product)}
                style={{
                  height: "28vh",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                <img
                  src={product?.imageurl?.trim() || defaultImage}
                  style={{
                    height: "17vh",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    borderRadius: "10px",
                    padding: "0.8vh 0.55vw",
                    width: "100%",
                  }}
                />
                <div
                  style={{
                    height: "7vh",
                    paddingLeft: "0.8vw",
                    fontWeight: 500,
                    fontSize: "1vw",
                    paddingRight: "0.8vw",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      fontSize: "1em",
                      fontWeight: 500,
                      color: "#0F0718",
                      height: "6vh",
                    }}
                  >
                    {product?.name}
                  </p>
                  <Row>
                    <Col
                      span={21}
                      style={{
                        fontSize: "1.25em",
                        fontWeight: "600",
                        color: "#0F0718",
                      }}
                    >
                      {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                      {product?.sunitprice}
                      {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                    </Col>
                    <Col
                      span={2}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "2px",
                      }}
                    >
                      <img src={removeBg} style={{ height: "1.8vh" }} />
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </InfiniteScroll>
  </Scrollbars>
</div> */}
          </div>

          {cart.items.length > 0 ? (
            <div style={{ background: "#fff", height: "100vh", width: "31%", position: "relative", fontSize: "1vw" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "2vh 1vw 0 1vw" }}>
                <span style={{ fontWeight: 600, fontSize: "1.5em", color: "#0F0718" }}>{getMultilingualText("Order Details")}</span>
                <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>{moment(cart.orderTime).format(userPreferences.dateFormat)}</span>
              </div>
              {localStorage.getItem("dineIn") === "Y" && cart.tableNo && (
                <p style={{ padding: "0 1vw", fontSize: "1.25em", color: "#0F0718", marginBottom: 0 }}>{/* {cart.tableNo} */}</p>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "0 1vw",
                  fontSize: "1.25em",
                  color: "#0F0718",
                  marginBottom: 0,
                }}
              >
                <span style={{ fontSize: "0.90rem" }}>{cart.tableNo}</span>

                {cart?.statusType === "OCU" && <span style={{ fontSize: "0.90rem" }}>{guestName}</span>}
              </div>
              {tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === cart?.customer?.cwrCustomerId ? (
                <button
                  style={{
                    marginLeft: "1.2vw",
                    color: "#0F0718",
                    backgroundColor: "#fff",
                    border: "1px solid #92909880",
                    fontSize: "0.85em",
                    borderRadius: "4px",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0.2vh 0.5vw",
                    cursor: "pointer",
                  }}
                  onClick={() => setDisplayCustomerSearch(true)}
                >
                  <img src={userIcon} style={{ height: 15, width: "1.5vw", marginRight: "0.2vw" }} />
                  Add Customer
                </button>
              ) : (
                <button
                  style={{
                    marginLeft: "1.2vw",
                    color: "#0F0718",
                    backgroundColor: "#fff",
                    border: "1px solid #92909880",
                    fontSize: "0.85em",
                    borderRadius: "4px",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0.2vh 0.5vw",
                    cursor: "pointer",
                  }}
                  onClick={() => setDisplayCustomerSearch(true)}
                >
                  <img src={userIcon} style={{ height: 15, width: "1.5vw", marginRight: "0.2vw" }} />
                  {cart?.customer?.name}
                </button>
              )}
              <hr style={{ color: "#92909880", width: "93%" }} />
              <Scrollbars
                autoHide
                style={{
                  // height: localStorage.getItem("dineIn") === "N" ? "40vh" : "57vh",
                  height: isAllParkedState || localStorage.getItem("dineIn") === "N" ? "50vh" : "62vh",
                  width: "100%",
                }}
              >
                <InfiniteScroll
                  dataLength={cart.items.length}
                  hasMore={true}
                  endMessage={
                    <p className="center">
                      <b>Yay! you have seen it all</b>
                    </p>
                  }
                  style={{ overflowX: "hidden" }}
                >
                  <div>
                    {Object.keys(groupedProducts).map((category, index) => (
                      <div key={index}>
                        <Text style={{ fontSize: "1em", fontWeight: "500", paddingLeft: "0.8rem", color: "#0F0718" }}>
                          {category} ({groupedProducts[category].length})
                        </Text>
                        {groupedProducts[category].map((item) => (
                          <div style={{ padding: "6px 10px" }}>
                            <div
                              key={item.id}
                              style={{ fontSize: "0.9vw", backgroundColor: selectedProductId === item.lineId ? "#f0f0f0" : "transparent" }}
                              onClick={() => {
                                if (item.parkedItem) return;
                                if (localStorage.getItem("dineIn") === "N") {
                                  setSelectedProductId(item.lineId);
                                  setSelectedProductInCart(item);
                                }
                              }}
                            >
                              <Row>
                                <Col
                                  span={5}
                                  style={{
                                    // height: "10vh",
                                    // height: "11.5vh",
                                    height: item.description ? "9vh" : "7.5vh",
                                    position: "relative",
                                  }}
                                >
                                  <img
                                    src={item.imageurl || defaultImage}
                                    alt={item.name}
                                    style={{
                                      // height: "9.5vh",
                                      // height: "11vh",
                                      height: item.description ? "7.5vh" : "7vh",
                                      maxWidth: "100%",
                                      objectFit: "cover",
                                      borderRadius: "5px",
                                      marginLeft: "5px",
                                    }}
                                  />
                                  <div
                                    onClick={async () => {
                                      if (item?.parkedItem) {
                                        const { workflowRules, approvers } = await getWorkflowData();
                                        const cancelKotRule = workflowRules.find((res) => res.eventName === "Cancel KOT");

                                        if (cancelKotRule) {
                                          dispatchEvent(cancelKotRule.eventName, cancelKotRule.ruleName, cancelKotRule.ruleCondition, approvers, async (eventData) => {
                                            if (eventData?.approvalGranted) {
                                              deleteProduct(item);
                                            } else {
                                              // Modal.error({
                                              //   title: "Approval Required",
                                              //   content: "You need approval to delete this item.",
                                              // });
                                            }
                                          });
                                        }
                                      } else {
                                        deleteProduct(item);
                                      }
                                    }}
                                    style={{
                                      position: "absolute",
                                      top: item.description ? "35px" : "28px",
                                      right: "5px",
                                      backgroundColor: "#fff",
                                      borderRadius: "20%",
                                      padding: "2px",
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                                    }}
                                  >
                                    <img
                                      src={DeleteProduct}
                                      alt="Delete"
                                      style={{
                                        width: "12px",
                                        height: "12px",
                                      }}
                                    />
                                  </div>
                                </Col>
                                <Col span={18} style={{ display: "flex", flexDirection: "column", paddingLeft: "0.5vw", position: "relative" }}>
                                  <Row>
                                    <Col span={22}>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <Tooltip title={item.name} placement="top">
                                          <Text
                                            style={{
                                              fontSize: "1em",
                                              fontWeight: "500",
                                              color: "#0F0718",
                                              marginRight: "0.3rem",
                                              maxWidth: "15vw",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {item.name}
                                          </Text>
                                        </Tooltip>
                                        <img
                                          src={addNote}
                                          style={{ width: "0.9rem", height: "0.9rem", cursor: "pointer" }}
                                          onClick={() => {
                                            setSelectedItem(item);
                                            setSelectedItemNotes(item);
                                            setNotesValue(item.notes || "");
                                            setNotesPopup(true);
                                          }}
                                          alt="Notes Icon"
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Text style={{ fontSize: "0.8em", color: "#929098", fontWeight: 400 }}>{item.description}</Text>
                                  <Text>
                                    {" "}
                                    {item?.selectedAddons?.map((subitem) => (
                                      <Row>
                                        <Col span={14}>
                                          <p style={{ fontSize: "0.7em", color: "#929098", marginBottom: 0 }}>+ {subitem.name}</p>
                                        </Col>
                                        {/* <Col span={10}>
                                          <p>+ {subitem.price}</p>
                                        </Col> */}
                                      </Row>
                                    ))}
                                  </Text>
                                  <Text style={{ fontWeight: 500, fontSize: "1.1em", color: "#0F0718", position: "absolute", bottom: 0 }}>
                                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                    {/* {item.nettotal.toFixed(item?.isQtyDesimal)} */}
                                    {toFixedTruncate(item.nettotal, item?.isQtyDesimal)}
                                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                                  </Text>

                                  <Space style={{ paddingLeft: "14vw", position: "absolute", bottom: 0 }}>
                                    <img
                                      src={minusIcon}
                                      height="20"
                                      width="20"
                                      onClick={async () => {
                                        const actualQtySTK = item?.weight - item?.sendQty;
                                        if (item.parkedItem) {
                                          if (item.weight > item?.sendQty && actualQtySTK < item?.weight) {
                                            const { workflowRules, approvers } = await getWorkflowData();
                                            const cancelKotRule = workflowRules.find((res) => res.eventName === "Cancel KOT");
                                            if (cancelKotRule) {
                                              dispatchEvent(cancelKotRule.eventName, cancelKotRule.ruleName, cancelKotRule.ruleCondition, approvers, async (eventData) => {
                                                if (eventData?.approvalGranted) {
                                                  parseFloat(item.weight) > 1 ? decreaseProductQty(item) : deleteProduct(item);
                                                }
                                              });
                                            } else {
                                              parseFloat(item.weight) > 1 ? decreaseProductQty(item) : deleteProduct(item);
                                            }
                                          } else {
                                            message.warn(`This item with quantity ${item.weight} has already been sent to the kitchen and cannot be modified.`);
                                          }
                                        } else {
                                          parseFloat(item.weight) > 1 ? decreaseProductQty(item) : deleteProduct(item);
                                        }
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "12px",
                                      }}
                                    />
                                    <Text style={{ margin: "0 6 px" }}>{item.weight}</Text>
                                    <img
                                      src={PlusIcon}
                                      height="20"
                                      width="20"
                                      onClick={() => {
                                        // if (item.parkedItem) return;
                                        increaseProductQty(item);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        // cursor: item.parkedItem ? "not-allowed" : "pointer",
                                        // opacity: item.parkedItem ? 0.5 : 1,
                                      }}
                                    />
                                  </Space>
                                </Col>
                              </Row>
                              {item.notes && item.notes.length > 0 && (
                                <Row>
                                  <Col span={20}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                      <p style={{ fontSize: "0.55rem", fontWeight: 400, color: "#929098", padding: 0, margin: 0 }}>Special Instructions: {item.notes}</p>
                                    </div>
                                  </Col>
                                </Row>
                              )}
                              <span
                                style={{
                                  background: Math.abs(item.discount) > 0 ? "#F8C519" : "",
                                  borderRadius: "3px",
                                  padding: "0.2vw",
                                  display: item.discountName ? "" : "none",
                                  fontSize: "0.65em",
                                }}
                              >
                                {Math.abs(item.discount) > 0 ? item.discountName ? <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} /> : "" : ""}{" "}
                                {Math.abs(item.discount) > 0 ? item.discountName || "" : ""}{" "}
                              </span>
                            </div>
                          </div>
                        ))}
                        <hr style={{ color: "#92909880", width: "92.5%" }} />
                      </div>
                    ))}
                  </div>
                </InfiniteScroll>
              </Scrollbars>
              <div style={{ padding: "1vh 0.6vw", position: "absolute", bottom: "1vh", fontSize: "1vw" }}>
                <div
                  onClick={() => setShowDetails(!showDetails)}
                  style={{
                    cursor: "pointer",
                    fontWeight: 500,
                    fontSize: "1em",
                    background: "#F3F4F9",
                    padding: "0.5vh 0.5vw",
                    borderRadius: "5px",
                    marginBottom: "1vh",
                  }}
                >
                  View Details {showDetails ? "▲" : "▼"}
                </div>
                {showDetails && (
                  <Scrollbars style={{ height: "18vh" }}>
                    <Space
                      direction="vertical"
                      style={{
                        width: "100%",
                        background: "#F3F4F9",
                        padding: "1vh 0.5vw",
                        borderRadius: "10px",
                        rowGap: "4px",
                      }}
                    >
                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Subtotal")}</Text>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {/* {(cart?.total - cart?.tax).toFixed(2)} */}
                          {toFixedTruncate(cart?.total - cart?.tax, pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                        </Text>
                      </Space>

                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Discount Sales")}</Text>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {/* {parseFloat(cart.discount).toFixed(2)} */}
                          {toFixedTruncate(cart.discount, pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                        </Text>
                      </Space>

                      <Space style={{ width: "100%", justifyContent: "space-between" }}>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Total Sales Tax")}</Text>
                        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                          {/* {parseFloat(cart.tax).toFixed(2)} */}
                          {toFixedTruncate(cart.tax, pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                        </Text>
                      </Space>

                      {serviceChargeAmount > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Service Charge")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {/* {parseFloat(serviceChargeAmount).toFixed(2)} */}
                            {toFixedTruncate(serviceChargeAmount, pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                          </Text>
                        </Space>
                      )}

                      {tipTotal > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Tip")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {/* {parseFloat(tipTotal).toFixed(2)} */}
                            {toFixedTruncate(tipTotal, pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                          </Text>
                        </Space>
                      )}

                      {deliveryChargeAmount > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Delivery Charge")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {/* {parseFloat(deliveryCharge).toFixed(2)} */}
                            {toFixedTruncate(deliveryChargeAmount, pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                          </Text>
                        </Space>
                      )}

                      {packingChargeAmount > 0 && (
                        <Space style={{ width: "100%", justifyContent: "space-between" }}>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>{getMultilingualText("Packing Charge")}</Text>
                          <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
                            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                            {/* {parseFloat(packingCharge).toFixed(2)} */}
                            {toFixedTruncate(packingChargeAmount, pricePrecision)}
                            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                          </Text>
                        </Space>
                      )}
                    </Space>
                  </Scrollbars>
                )}
                <Space style={{ width: "100%", justifyContent: "space-between", marginTop: "2px" }}>
                  <Text style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 600 }}>{getMultilingualText("Total Amount")}</Text>
                  <Text style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 600 }}>
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {/* {(Math.floor(parseFloat(cart.total) * 100) / 100 + AdditionalChargesTotal).toFixed(2)} */}
                    {toFixedTruncate(Math.floor(parseFloat(cart.total) * 100) / 100 + AdditionalChargesTotal, pricePrecision)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                  </Text>
                </Space>
                {isAllParkedState || localStorage.getItem("dineIn") === "N" ? (
                  // <Row style={{ padding: "0 5px 0 0 " }}>
                  //   <Col span={12} style={{ display: "flex", alignItems: "center", padding: "1.5vh 0 0 0.5vw" }}>
                  //     <p style={{ marginBottom: 0, color: "#0F0718", fontSize: "1em", fontWeight: 500 }}>Additional Charges</p>
                  //     <PlusOutlined
                  //       style={{
                  //         cursor: "pointer",
                  //         paddingLeft: "1vw",
                  //       }}
                  //       onClick={() => {
                  //         handleAdditionalCharges();
                  //       }}
                  //     />
                  //   </Col>
                  //   <Col span={12} style={{ display: "flex", alignItems: "center", padding: "1vh 0 0 0.5vw", justifyContent: "right" }}>
                  //     <Button
                  //       style={{
                  //         border: "1px solid rgba(146, 144, 152, 0.5)",
                  //         borderRadius: "10px",
                  //         color: "#2F3856",
                  //         height: "5.5vh",
                  //         fontSize: "1em",
                  //         fontWeight: "500",
                  //       }}
                  //       onClick={() => {
                  //         setShowSplitBill(true);
                  //       }}
                  //     >
                  //       <TeamOutlined />
                  //       Split Bill
                  //     </Button>
                  //   </Col>
                  // </Row>
                  <Row style={{ padding: "0 5px 0 0 " }}>
                    {posConfig?.enableAdditionalCharges === "Y" && (
                      <Col
                        span={posConfig?.enableAdditionalCharges === "Y" && posConfig?.enableSplitBill === "Y" ? 12 : 24}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "1.5vh 0 0 0.5vw",
                        }}
                      >
                        <p style={{ marginBottom: 0, color: "#0F0718", fontSize: "1em", fontWeight: 500 }}>Additional Charges</p>
                        <PlusOutlined
                          style={{
                            cursor: "pointer",
                            paddingLeft: "1vw",
                          }}
                          onClick={handleAdditionalCharges}
                        />
                      </Col>
                    )}

                    {posConfig?.enableSplitBill === "Y" && (
                      <Col
                        span={posConfig?.enableAdditionalCharges === "Y" && posConfig?.enableSplitBill === "Y" ? 12 : 24}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "1vh 0 0 0.5vw",
                          justifyContent: "right",
                        }}
                      >
                        <Button
                          style={{
                            border: "1px solid rgba(146, 144, 152, 0.5)",
                            borderRadius: "10px",
                            color: "#2F3856",
                            height: "5.5vh",
                            fontSize: "1em",
                            fontWeight: "500",
                          }}
                          onClick={() => {
                            setShowSplitBill(true);
                          }}
                        >
                          <TeamOutlined />
                          Split Bill
                        </Button>
                      </Col>
                    )}
                  </Row>
                ) : null}
                {(isAllParkedState || localStorage.getItem("dineIn") === "N") && (
                  <div>
                    <Space direction="horizontal" style={{ paddingTop: "2vh", fontSize: "1vw" }}>
                      {tillData?.tillAccess?.manualDiscount === "Y" && (
                        <Button
                          style={{
                            width: "27.1vw",
                            border: "1px solid rgba(146, 144, 152, 0.5)",
                            borderRadius: "10px",
                            color: "#2F3856",
                            height: "5.5vh",
                            fontSize: "1em",
                            fontWeight: "500",
                            marginLeft: "0.3em",
                          }}
                          onClick={manualDiscountRestaurant}
                        >
                          <img src={DiscountIcon} style={{ paddingRight: "0.3rem", height: "2.5vh" }} />
                          <span>Add Discount</span>
                        </Button>
                      )}
                      {/* <Button
                        style={{
                          width: "13.5vw",
                          borderRadius: "10px",
                          color: "#2F3856",
                          height: "5.5vh",
                          fontSize: "1em",
                          fontWeight: "500",
                        }}
                      >
                        <img src={printBill} style={{ paddingRight: "0.3rem", height: "2.5vh" }} />
                        <span>Print Bill</span>
                      </Button> */}
                    </Space>
                  </div>
                )}
                <div>
                  <Space direction="horizontal" style={{ paddingTop: "2vh", fontSize: "1vw" }}>
                    {/* {localStorage.getItem("dineIn") === "Y" && ( */}
                    {posConfig?.allowCancelKOT === "Y" && (
                      // cart.length > 0 && cart.some((item) => item.parkedItem === true) &&
                      <Button
                        onClick={() => handleVoid(selectedTable)}
                        style={{
                          width: "7.8vw",
                          border: "1px solid rgba(146, 144, 152, 0.5)",
                          borderRadius: "10px",
                          color: "#2F3856",
                          height: "6vh",
                          fontSize: "1em",
                          fontWeight: "500",
                        }}
                      >
                        {getMultilingualText("Cancel")}
                      </Button>
                    )}
                    {/* <Button
                      onClick={() => {
                        // if (localStorage.getItem("dineIn") === "N") {
                        if (isAllParkedState || localStorage.getItem("dineIn") === "N") {
                          if (saleType === "TA") {
                            const cartObj = JSON.parse(localStorage.getItem("cartObj"));
                            let updatedCart = {
                              ...cartObj,
                              sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
                            };
                            setCart(updatedCart);
                            localStorage.setItem("cartObj", JSON.stringify(updatedCart));
                          }
                          setPaymentVisible(true);
                          // setKeyValue("3");
                        } else if (showSendToKitchen) {
                          handleOrder();
                        } else {
                          handleOrder();
                        }
                      }}
                      style={{
                        width: localStorage.getItem("dineIn") === "Y" && posConfig?.allowCancelKOT === "N" ? "27.5vw" : "19.5vw",
                        borderRadius: "10px",
                        backgroundColor: "#2F3856",
                        color: "#fff",
                        height: "6vh",
                        fontSize: "1em",
                        fontWeight: "500",
                      }}
                    >
                      {isAllParkedState || localStorage.getItem("dineIn") === "N" || !showSendToKitchen
                        ? `${getMultilingualText("Pay Bill")}`
                        : `${getMultilingualText("Send To Kitchen")}`}
                    </Button> */}

                    <Button
                      onClick={() => {
                        if (isAllParkedState || localStorage.getItem("dineIn") === "N") {
                          if (saleType === "TA") {
                            const cartObj = JSON.parse(localStorage.getItem("cartObj"));
                            let updatedCart = {
                              ...cartObj,
                              sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
                            };
                            setCart(updatedCart);
                            localStorage.setItem("cartObj", JSON.stringify(updatedCart));
                          }
                          setPaymentVisible(true);

                          setTimeout(() => {
                            paymentModalInputRef.current?.focus();
                            paymentModalInputRef.current?.select();
                          }, 200);
                        } else if (showSendToKitchen) {
                          handleOrder();
                        } else {
                          handleOrder();
                        }
                      }}
                      style={{
                        width: localStorage.getItem("dineIn") === "Y" && posConfig?.allowCancelKOT === "N" ? "27.5vw" : "19.5vw",
                        borderRadius: "10px",
                        backgroundColor: "#2F3856",
                        color: "#fff",
                        height: "6vh",
                        fontSize: "1em",
                        fontWeight: "500",
                      }}
                    >
                      {isAllParkedState || localStorage.getItem("dineIn") === "N" || !showSendToKitchen
                        ? `${getMultilingualText("Pay Bill")}`
                        : `${getMultilingualText("Send To Kitchen")}`}
                    </Button>

                    {/* localStorage.getItem("dineIn") === "N" || */}
                  </Space>
                </div>
              </div>
            </div>
          ) : null}

          {/* Modal for product details */}

          {/* modal for add on's starts */}

          <Modal
            closable={false}
            footer={null}
            bodyStyle={{ padding: 13, background: "#fff" }}
            visible={displayAddOnSelection}
            onCancel={handleAddOnModalClose}
            centered
            // width={
            //   (addOnsList?.requiredList?.length > 0 && Object.entries(_.groupBy(addOnsList?.optionsList, "mAddonGroup.name"))?.length === 0) ||
            //   (addOnsList?.requiredList?.length === 0 && Object.entries(_.groupBy(addOnsList?.optionsList, "mAddonGroup.name"))?.length === 1)
            //     ? "35%"
            //     : addOnsList?.requiredList?.length > 0 && Object.entries(_.groupBy(addOnsList?.optionsList, "mAddonGroup.name"))?.length === 1
            //     ? "48%"
            //     : "60%"
            // }
            width={"28%"}
          >
            <Row style={{ marginBottom: 0, paddingBottom: 0 }}>
              <Col span={24} style={{ paddingBottom: 0, fontSize: "1vw" }}>
                <img src={selectedProduct?.imageurl} alt={selectedProduct?.name} style={{ width: "100%", borderRadius: "5px", height: "25vh", display: "block" }} />

                <div style={{ padding: "10px 5px 0 5px", fontSize: "1vw" }}>
                  <img src={removeBg} style={{ height: "1.9vh", marginBottom: "10px", marginTop: "0.6em" }} />

                  <span style={{ fontSize: "1.2em", fontWeight: "500", color: "#0F0718", paddingLeft: "0.7vw" }}>{selectedProduct?.name}</span>
                  <span style={{ fontSize: "1.2em", fontWeight: "600", color: "#0F0718", paddingLeft: "2.7vw" }}>
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {selectedProduct?.sunitprice}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                  </span>
                </div>
                <p style={{ paddingLeft: "5px", paddingRight: "5px", color: "#929098", fontSize: "1em", marginBottom: 0 }}>{selectedProduct?.description}</p>
              </Col>

              <Row>
                <Col span={9} style={{ padding: 0 }} />
                <Col span={16} style={{ display: "flex", paddingLeft: "18.5vw", paddingTop: 0, paddingBottom: 0 }}>
                  <Button
                    icon={<MinusOutlined style={{ fontSize: "15px" }} />}
                    style={{
                      width: "100px",
                      height: "28px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingRight: 6,
                      marginRight: "15px",
                      paddingLeft: 6,
                      borderRadius: "5px",
                      paddingTop: 0,
                    }} // Set width, height, and center icon
                    onClick={() => handleQty("minus")}
                  />
                  <p style={{ fontSize: "1.25em", color: "#0F0718", fontWeight: 500 }}>{selectedProduct?.weight || 1}</p>
                  <Button
                    icon={<PlusOutlined style={{ fontSize: "15px", color: "#fff" }} />}
                    style={{
                      width: "100px",
                      height: "28px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingRight: 6,
                      marginLeft: "15px",
                      paddingLeft: 6,
                      backgroundColor: "#2F3856",
                      borderRadius: "5px",
                    }} // Set width, height, and center icon
                    onClick={() => handleQty("plus")}
                  />
                </Col>
              </Row>
            </Row>
            <p style={{ fontSize: "1.25em", color: "#0F0718", fontWeight: 500, marginBottom: 5, paddingLeft: "5px" }}>{getMultilingualText("Add On's")}</p>
            <Scrollbars autoHide className="addOnsModalScroll">
              <Row>
                <Col span={24} style={{ paddingRight: 3, paddingBottom: 10 }}>
                  <Card bodyStyle={{ padding: 5 }} style={data.restaurantPos.content.addOnSelectionModal.mainCard}>
                    {/* Required Add-Ons */}
                    {addOnsList?.requiredList?.length > 0 && (
                      <div style={{ fontSize: "1vw" }}>
                        <Radio.Group
                          value={_.intersection(addOnsList?.requiredList || [], selectedAddons)?.[0] || {}}
                          onChange={(e) => handleAddOnValue(e, "addOnRadio")}
                          style={{ width: "100%" }}
                        >
                          {addOnsList?.requiredList?.map((item) => (
                            <Card key={item.mProductAddOnId} style={data.restaurantPos.content.addOnSelectionModal.addOnCard} bodyStyle={{ padding: 10 }}>
                              <Row>
                                <Col span={24}>
                                  <Radio value={item} style={{ fontSize: "1vw" }}>
                                    <span style={data.restaurantPos.content.addOnSelectionModal.addOnTitle}>{item.name}</span>
                                  </Radio>
                                </Col>
                              </Row>
                            </Card>
                          ))}
                        </Radio.Group>
                      </div>
                    )}

                    {addOnsList?.optionsList?.length > 0 && (
                      <div style={{ background: "#F3F4F9" }}>
                        {Object.entries(_.groupBy(addOnsList?.optionsList, "mAddonGroup.name")).map(([key, value]) => (
                          <div key={key} style={{ background: "#F3F4F9" }}>
                            {value?.map((item) => (
                              <Card key={item.mProductAddOnId} style={data.restaurantPos.content.addOnSelectionModal.addOnCard} bodyStyle={{ padding: 10, color: "#0F0718" }}>
                                <Row>
                                  <Col span={20}>
                                    <Checkbox
                                      checked={selectedAddons.findIndex((itemAddOn) => itemAddOn.mProductAddOnId === item.mProductAddOnId) !== -1}
                                      value={item}
                                      onChange={(e) => handleAddOnValue(e, "addOnCheck")}
                                    >
                                      <span style={data.restaurantPos.content.addOnSelectionModal.addOnTitle}>{item.name}</span>
                                    </Checkbox>
                                  </Col>
                                  <Col span={4}>
                                    <span style={data.restaurantPos.content.addOnSelectionModal.addOnPrice}>
                                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                      {item.price} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                                    </span>
                                  </Col>
                                </Row>
                              </Card>
                            ))}
                          </div>
                        ))}
                      </div>
                    )}
                  </Card>
                </Col>
              </Row>
            </Scrollbars>

            <Row style={{}}>
              <Col span={24} style={{ fontSize: "1vw" }}>
                <Button style={data.restaurantPos.content.orderCart.checkoutBtn} className="addButton" onClick={handleAdd}>
                  <span style={data.restaurantPos.content.orderCart.checkoutBtn.label}>{getMultilingualText("Add to Cart")}</span>
                </Button>
              </Col>
            </Row>
          </Modal>

          <Drawer
            placement="bottom"
            height="53vh"
            title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "2vh",
                  fontSize: "1vw",
                }}
              >
                <p
                  style={{
                    fontSize: "1.5em",
                    marginTop: "3vh",
                    fontWeight: "500",
                    color: "#0F0718",
                    flex: 1,
                    textAlign: "center",
                  }}
                >
                  Add Notes for Item
                </p>
                <img
                  src={Close}
                  onClick={() => {
                    setNotesPopup(false);
                    setNotesValue("");
                  }}
                  style={{
                    marginLeft: "auto",
                    paddingBottom: "4vh",
                    paddingTop: "2vh",
                    cursor: "pointer",
                    width: "1.5vw",
                  }}
                />
              </div>
            }
            closeIcon={null}
            className="filter"
            bodyStyle={{ paddingTop: 0 }}
            visible={notesPopup}
            closable={true}
            onClose={() => {
              setNotesPopup(false);
            }}
            footer={null}
          >
            <Row style={{ padding: "0 5vw", fontSize: "1vw" }}>
              <Col
                span={11}
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                }}
              >
                <TextArea id="notes-input" style={{ resize: "none" }} maxLength={200} onChange={(e) => setNotesValue(e.target.value)} value={notesValue} rows={9} />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "8px",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontSize: "0.8em",
                      color: "#929098",
                      fontWeight: 500,
                    }}
                  >
                    Max Characters : 200
                  </span>
                  <button
                    style={{
                      height: "5vh",
                      width: "10vw",
                      backgroundColor: "#2F3856",
                      color: "#fff",
                      border: "none",
                      borderRadius: "3px",
                      padding: "0 12px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setNotesValue("");
                      const updatedCartItems = cart.items.map((cartItem) => (cartItem.id === selectedItem.id ? { ...cartItem, notes: "" } : cartItem));
                      setCart({ ...cart, items: updatedCartItems });
                      if (selectedItem) {
                        setSelectedItem({ ...selectedItem, notes: "" });
                      }
                      setNotesPopup(false);
                    }}
                  >
                    Clear Notes
                  </button>
                </div>
              </Col>

              <Col span={12} offset={1}>
                <Keyboard
                  theme={"hg-theme-default aprvl"}
                  onKeyPress={(button) => {
                    if (button === "{backspace}") {
                      setNotesValue((prev) => prev.slice(0, -1));
                    } else if (button === "{space}") {
                      setNotesValue((prev) => prev + " ");
                    } else if (button === "{shift}" || button === "{lock}") {
                      handleShift();
                    } else if (button === "{number}") {
                      setLayoutName("number");
                    } else if (button === "{numbers}") {
                      setLayoutName("numbers");
                    } else if (button === "{small}") {
                      setLayoutName("shift");
                    } else if (button === "{caps}") {
                      setLayoutName("default");
                    } else if (button === "{enter}") {
                      if (selectedItem) {
                        const updatedCartItems = cart.items.map((cartItem) => (cartItem.lineId === selectedItem.lineId ? { ...cartItem, notes: notesValue } : cartItem));
                        setCart({ ...cart, items: updatedCartItems });
                        selectedItem.notes = notesValue;
                        setInstructions(notesValue);
                        setNotesPopup(false);
                      }
                    } else {
                      setNotesValue((prev) => prev + button);
                    }
                  }}
                  layoutName={layoutName}
                  display={{
                    "{abc}": "ABC",
                    "{smileys}": "\uD83D\uDE03",
                    "{back}": "Enter",
                    "{numbers}": "123",
                    "{number}": "123",
                    "{bksp}": "backspace",
                    "{backspace}": "⌫",
                    "{shift}": "⇧",
                    "{tab}": "tab",
                    "{lock}": "lock",
                    "{enter}": "Enter",
                    "{space}": "Space",
                    "{caps}": "ABC",
                    "{small}": "abc",
                  }}
                  layout={
                    posConfig?.keyboardLanguage === "Y" && posConfig?.selectedKeyboardLanguage === "ar"
                      ? {
                          shift: ["ض ص ث ق ف غ ع ه خ ح ج د", "ش س ي ب ل ا ت ن م ك ط", "{shift} ئ ء ؤ ر ى ة و ز ظ أ إ آ ـ {backspace}", "{number} {space} {enter}"],
                          numbers: ["١ ٢ ٣ ٤ ٥ ٦ ٧ ٨ ٩ ٠", "! @ # $ % ^ & * ( )", "- . ، _ / ؛ ؟ {backspace}", "{caps} {space} {enter}"],
                          number: ["١ ٢ ٣ ٤ ٥ ٦ ٧ ٨ ٩ ٠", "! @ # $ % ^ & * ( )", "- . ، _ / ؛ ؟ {backspace}", "{small} {space} {enter}"],
                          default: ["ض ص ث ق ف غ ع ه خ ح ج د", "ش س ي ب ل ا ت ن م ك ط", "{shift} ئ ء ؤ ر ى ة و ز ظ أ إ آ ـ {backspace}", "{numbers} {space} {enter}"],
                        }
                      : {
                          shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {backspace}", "{number} {space} {enter}"],
                          numbers: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{caps} {space} {enter}"],
                          number: ["1 2 3 4 5 6 7 8 9 0", "! @ # $ % ^ & * ( )", "- . , _ / ` {backspace}", "{small} {space} {enter}"],
                          default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {backspace}", "{numbers} {space} {enter}"],
                        }
                  }
                />
              </Col>
            </Row>
          </Drawer>
          {/* {paymentVisible && <OrderListComponent {...props} />} */}
        </div>
      )}
      <Drawer
        placement="bottom"
        closable={false}
        maskClosable={false}
        className="filter"
        bodyStyle={{ paddingBottom: 0 }}
        onClose={() => {
          setFilterDrawer(false);
          setProductSearchInput("");
          setSelectCategotyList([]);
          setProductsData(saleTypeProducts);
        }}
        id="sm-drawer-close"
        height="89vh"
        visible={filterDrawer}
      >
        <Col span={24} style={{ fontSize: "1vw", padding: "0 2vw", height: "83vh" }}>
          {loading ? (
            <>
              {[...Array(12)].map((_, index) => (
                <Card key={index} style={{ marginBottom: "1vh", padding: "12px", borderRadius: "8px" }}>
                  <Skeleton active paragraph={{ rows: 2 }} />
                </Card>
              ))}
            </>
          ) : (
            <>
              {/* Close button */}
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1vh" }}>
                <CloseOutlined
                  onClick={() => {
                    setFilterDrawer(false);
                    setProductSearchInput("");
                    setSelectCategotyList([]);
                    setProductsData(saleTypeProducts);
                  }}
                  style={{ fontSize: "1.2vw", cursor: "pointer" }}
                />
              </div>

              {/* Search + Sort */}
              <Row style={{ marginBottom: "1vh", width: "100%", display: "flex", alignItems: "center" }}>
                <Col span={24}>
                  <Input
                    ref={productPanelSearchRef}
                    placeholder="Search for products by code/name"
                    id="sm-product-search"
                    value={productSearchInput}
                    onChange={(e) => {
                      setProductSearchInput(e.target.value.toLowerCase());
                    }}
                    style={{
                      width: "100%",
                      borderRadius: "7px",
                      padding: "0.8vh 0.8vw",
                      borderColor: "#fff",
                      backgroundColor: "#fff",
                      height: "5vh",
                      fontSize: "1em",
                    }}
                    onFocus={() => {
                      setOpen(true);
                      setTimeout(() => {
                        setInputName("productSearch1");
                        keyboard?.current?.setInput(productSearchInput);
                      }, 150);
                    }}
                    onPressEnter={() => {
                      const filtered = applySearchFilter(productSearchInput, selectCategotyList);
                      setProductsData(filtered);
                      keyboard?.current?.setInput(productSearchInput);
                    }}
                    prefix={
                      <img
                        src={SearchIcon}
                        alt=""
                        onClick={() => {
                          const value = productSearchInput.toLowerCase().trim();
                          const filtered = saleTypeProducts.filter((product) => {
                            const matchesText =
                              product.name.toLowerCase().includes(value) || product.value?.toLowerCase().includes(value) || product.code?.toLowerCase().includes(value);
                            const matchesCategory = selectCategotyList.length === 0 || selectCategotyList.includes(product.mProductCategoryId);
                            return matchesText && matchesCategory;
                          });
                          setProductsData(filtered);
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    }
                    suffix={
                      productSearchInput?.length > 0 ? (
                        <CloseSquareFilled
                          style={{ fontSize: "20px", color: "#2F3856" }}
                          onClick={async () => {
                            setProductSearchInput("");
                            if (selectCategotyList.length === 0) {
                              setProductsData(saleTypeProducts);
                            } else {
                              setProductsData(saleTypeProducts.filter((product) => selectCategotyList.includes(product.mProductCategoryId)));
                            }
                            setTimeout(() => {
                              setOpen(false);
                              const productSearchInput = document.getElementById("sm-product-search");
                              if (productSearchInput) {
                                productSearchInput.blur();
                              }
                              keyboard?.current?.setInput("");
                            }, 200);
                          }}
                        />
                      ) : null
                    }
                  />
                </Col>
              </Row>

              {/* Categories */}
              <div style={{ display: "flex", overflowX: "auto", paddingBottom: "1%", paddingLeft: "0.1rem" }}>
                {productCategoriesList
                  .slice()
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((category) => (
                    <button
                      key={category.mProductCategoryId}
                      onClick={() => {
                        const newCategory = [category.mProductCategoryId];
                        setSelectCategotyList(newCategory);
                        setCategorieName(category.name);
                        restaurantProductCategory(category.mProductCategoryId);
                        setCategorieFlag(true);
                        const filtered = applySearchFilter(productSearchInput, newCategory);
                        setProductsData(filtered);
                      }}
                      style={{
                        background: selectCategotyList.includes(category.mProductCategoryId) ? "#eff6ff" : "#fff",
                        color: selectCategotyList.includes(category.mProductCategoryId) ? "#2563eb" : "#0F0718",
                        fontWeight: 500,
                        border: "none",
                        padding: "0.5vh 0.5vw",
                        height: "6vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        whiteSpace: "nowrap",
                        fontSize: "1em",
                        fontFamily: "Inter",
                        cursor: "pointer",
                      }}
                    >
                      {category.name}
                      <Badge
                        count={saleTypeProducts.filter((product) => product.mProductCategoryId === category.mProductCategoryId).length}
                        style={{
                          backgroundColor: "#f5f5f5",
                          color: "#0F0718",
                          fontSize: "0.8em",
                          padding: "0px 8px",
                          borderRadius: "10px",
                          marginLeft: "0.5em",
                        }}
                      />
                    </button>
                  ))}
              </div>

              {/* Product Grid */}
              <Scrollbars style={{ height: "65vh" }}>
                {/* === Determine showImage flag once === */}
                {(() => {
                  // Helper: Minimal card when showImage is N
                  const MinimalCard = ({ product }) => (
                    <Card
                      key={product.mProductId}
                      style={{
                        borderRadius: "10px",
                        border: "1px solid #e8e8e8",
                        padding: "10px",
                        cursor: "pointer",
                        color: "#0F0718",
                        fontWeight: "500",
                        backgroundColor: getColorFromId(product.mProductId),
                        overflow: "hidden",
                        height: "90px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        position: "relative",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        product?.productAddons?.length > 0 ? handleAddOnModal(product, e) : pickProduct(product);
                      }}
                    >
                      <p
                        title={product.name}
                        style={{
                          fontWeight: 500,
                          fontSize: "13px",
                          margin: 0,
                          lineHeight: "1.4",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                          padding: "0 4px",
                        }}
                      >
                        {product.name}
                      </p>

                      <p
                        style={{
                          color: "green",
                          fontWeight: 500,
                          fontSize: "12px",
                          margin: 0,
                          position: "absolute",
                          bottom: "8px",
                          right: "10px",
                        }}
                      >
                        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                        {product.sunitprice.toFixed(2)}
                        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
                      </p>
                    </Card>
                  );

                  // Helper: Rich card when showImage is Y
                  const RichCard = ({ product }) => (
                    <Card
                      key={product.mProductId}
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #e8e8e8",
                        cursor: "pointer",
                        position: "relative",
                        padding: "12px",
                        overflow: "visible",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        product?.productAddons?.length > 0 ? handleAddOnModal(product, e) : pickProduct(product);
                      }}
                    >
                      <div
                        style={{
                          height: "60px",
                          background: "#f5f5f5",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "8px",
                          overflow: "visible",
                          position: "relative",
                        }}
                      >
                        <img
                          src={product.imageurl || DefaultProductImage}
                          alt={product.name}
                          style={{
                            width: product.imageurl ? "100%" : "40px",
                            height: product.imageurl ? "100%" : "40px",
                            objectFit: product.imageurl ? "cover" : "contain",
                            margin: product.imageurl ? "0" : "auto",
                          }}
                        />
                        {product.isBestSeller && (
                          <div
                            style={{
                              position: "absolute",
                              top: "4px",
                              right: "4px",
                              backgroundColor: "#eab308",
                              padding: "2px 6px",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: "10px",
                              fontSize: "10px",
                              fontWeight: 500,
                              zIndex: 1,
                              pointerEvents: "none",
                            }}
                          >
                            <StarOutlined style={{ fontSize: "10px", marginRight: "4px" }} />
                            Best
                          </div>
                        )}
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                        <h3
                          title={product?.name}
                          style={{
                            fontSize: "0.8em",
                            fontWeight: "600",
                            color: "#0F0718",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {product.name}
                        </h3>
                        <div style={{ fontSize: "0.8rem", color: "#4b5563", marginBottom: "0.25rem" }}>
                          <span style={{ fontWeight: "500" }}>{product.value}</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <span style={{ fontSize: "0.9em", fontWeight: "700", color: "#389e0d" }}>
                            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                            {product.sunitprice.toFixed(2)}
                            {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}/{product.uomName}
                          </span>
                          <Col
                            span={2}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginLeft: "2px",
                            }}
                          >
                            {getFoodTypeIcon(product.foodType) && <img src={getFoodTypeIcon(product.foodType)} style={{ height: "1.8vh" }} />}
                          </Col>
                        </div>
                      </div>
                    </Card>
                  );

                  // Render Best Sellers
                  const renderBestSellers = () => {
                    const filtered = frequentProducts.filter((p) => selectCategotyList.length === 0 || selectCategotyList.includes(p.mProductCategoryId));
                    if (filtered.length === 0) return null;

                    return (
                      <div style={{ marginBottom: "2vh" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "3px", marginBottom: "1vh" }}>
                          <h2 style={{ fontSize: "1.2em", fontWeight: 500, color: "#0F0718" }}>Best Sellers</h2>
                          <Badge
                            count={filtered.length}
                            style={{
                              backgroundColor: "#f5f5f5",
                              color: "#0F0718",
                              fontSize: "0.8em",
                              padding: "0px 8px",
                              borderRadius: "10px",
                            }}
                          />
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "12px" }}>
                          {filtered.map((product) =>
                            showImage ? <RichCard key={product.mProductId} product={product} /> : <MinimalCard key={product.mProductId} product={product} />
                          )}
                        </div>
                      </div>
                    );
                  };

                  // Render All Products
                  const renderAllProducts = () => {
                    const filtered = nonfrequentProducts.filter((p) => selectCategotyList.length === 0 || selectCategotyList.includes(p.mProductCategoryId));
                    if (filtered.length === 0) return null;

                    return (
                      <div style={{ marginBottom: "2vh" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "3px", marginBottom: "1vh" }}>
                          <h2 style={{ fontSize: "1.2em", fontWeight: 500, color: "#0F0718" }}>All Products</h2>
                          <Badge
                            count={filtered.length}
                            style={{
                              backgroundColor: "#f5f5f5",
                              color: "#0F0718",
                              fontSize: "0.8em",
                              padding: "0px 8px",
                              borderRadius: "10px",
                            }}
                          />
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "12px" }}>
                          {filtered.map((product) =>
                            showImage ? <RichCard key={product.mProductId} product={product} /> : <MinimalCard key={product.mProductId} product={product} />
                          )}
                        </div>
                      </div>
                    );
                  };

                  return (
                    <>
                      {renderBestSellers()}
                      {renderAllProducts()}
                    </>
                  );
                })()}
              </Scrollbars>
            </>
          )}
        </Col>
      </Drawer>
      <Drawer
        title={
          <div style={{ display: "flex", fontSize: "1vw", alignItems: "center" }}>
            <p style={{ fontSize: "1.5em", fontWeight: 600, color: "#0F0718", flex: 1 }}>Additional Charges</p>
            <img
              src={Close} // Ensure Close is imported or replace with a valid image path
              onClick={() => {
                resetToInitialState();
                setAdditionalCharges(false);
              }}
              style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }}
            />
          </div>
        }
        closable={true}
        maskClosable={false}
        placement="right"
        closeIcon={null}
        visible={additionalCharges}
        width={400} // Increased width for a cleaner look
        onClose={() => {
          resetToInitialState();
          setAdditionalCharges(false);
        }}
      >
        {/* Service Charge */}
        <div style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
          <span style={{ fontSize: "15px", fontWeight: 550 }}>% Service Charge</span>
          <Switch checked={serviceChargeEnabled} onChange={(checked) => setServiceChargeEnabled(checked)} style={{ marginRight: "10px" }} />
        </div>
        <div style={{ marginBottom: "20px", display: "flex", alignItems: "center" }}>
          <Select
            value={serviceChargePercentage}
            onChange={(value) => setServiceChargePercentage(value)} // Handle change
            disabled={!serviceChargeEnabled}
            style={{ width: "80px", marginRight: "10px" }}
          >
            <Option value={5}>5%</Option>
            <Option value={7}>7%</Option>
            <Option value={10}>10%</Option>
            <Option value={12}>12%</Option>
            <Option value={15}>15%</Option>
          </Select>
          <span style={{ marginLeft: "10px" }}>
            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
            {/* {serviceChargeAmount.toFixed(2)} */}
            {toFixedTruncate(serviceChargeAmount, pricePrecision)}
            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
          </span>
        </div>

        {/* Tip */}
        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", fontSize: "15px", fontWeight: 550 }}>
            {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
            Tip
            {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
          </p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Select
              value={tipMode}
              onChange={(value) => {
                setTipMode(value); // Handle change for tip mode
                if (value === "Percentage") {
                  setTipPercentage(0);
                  setTipAmount(0);
                } else {
                  setTipPercentage(0);
                  setTipAmount(0);
                }
              }}
              style={{ width: 130, marginRight: "10px" }}
            >
              <Option value="Percentage">Percentage</Option>
              <Option value="Amount">Amount</Option>
            </Select>
            {tipMode === "Percentage" ? (
              <Select
                value={tipPercentage}
                onChange={(value) => setTipPercentage(value)} // Handle change for tip percentage
                style={{ width: "80px", marginRight: "10px" }}
              >
                <Option value={0}>0%</Option>
                <Option value={5}>5%</Option>
                <Option value={7}>7%</Option>
                <Option value={10}>10%</Option>
                <Option value={12}>12%</Option>
                <Option value={15}>15%</Option>
              </Select>
            ) : (
              <Input
                value={tipAmount}
                onChange={(e) => setTipAmount(parseFloat(e.target.value) || 0)} // Handle change for tip amount
                style={{ width: "100px", textAlign: "right" }}
                prefix={`${currenciesList[0].currSymbol}`}
              />
            )}
          </div>
        </div>

        {/* Delivery Charge */}
        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
            <span style={{ marginRight: "8px" }}>
              <CarOutlined />
            </span>{" "}
            Delivery Charge
          </p>
          <Input
            value={deliveryCharge}
            onChange={(e) => setDeliveryCharge(parseFloat(e.target.value) || 0)} // Handle change for delivery charge
            style={{ width: "100px", textAlign: "right" }}
            prefix={`${currenciesList[0].currSymbol}`}
          />
        </div>

        {/* Packing Charge */}
        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
            <span style={{ marginRight: "8px" }}>
              <GiftOutlined />
            </span>{" "}
            Packing Charge
          </p>
          <Input
            value={packingCharge}
            onChange={(e) => setPackingCharge(parseFloat(e.target.value) || 0)} // Handle change for packing charge
            style={{ width: "100px", textAlign: "right" }}
            prefix={`${currenciesList[0].currSymbol}`}
          />
        </div>

        {/* Rounding */}
        <div style={{ marginBottom: "20px" }}>
          <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
            <span style={{ marginRight: "8px" }}>
              <ReloadOutlined />
            </span>{" "}
            Rounding
          </p>
          <Select
            value={roundingOption}
            onChange={(value) => setRoundingOption(value)} // Handle change for rounding option
            style={{ width: "150px" }}
          >
            <Option value="No Rounding">No Rounding</Option>
            <Option value="Round Up">Round Up</Option>
            <Option value="Round Down">Round Down</Option>
          </Select>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "50px" }}>
          <Button
            style={{
              backgroundColor: "#fff",
              color: "#2F3856",
              height: "40px",
              width: "100px",
              borderRadius: "5px",
              marginRight: "10px",
            }}
            onClick={() => {
              resetToInitialState();
              setAdditionalCharges(false);
            }}
          >
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "#2F3856",
              color: "#fff",
              height: "40px",
              width: "140px",
              borderRadius: "5px",
              textAlign: "center",
            }}
            onClick={handleApplyCharges}
          >
            Apply Charges
          </Button>
        </div>
      </Drawer>

      <Modal
        centered
        visible={showSplitBill}
        closable={false}
        footer={null}
        style={{ borderRadius: "10px" }}
        bodyStyle={{ padding: "10px" }}
        // modalRender={(modal) => <div style={{ borderRadius: "10px 10px 10px 10px", overflow: "hidden", height: "66vh", width: "90%" }}>{modal}</div>}
        modalRender={(modal) => (
          <div
            style={{
              borderRadius: "10px",
              overflow: "hidden",
              height: "66vh",
              width: "90%",
            }}
          >
            {React.cloneElement(modal, {
              style: {
                ...modal.props.style,
                borderRadius: "10px",
                overflow: "hidden",
              },
            })}
          </div>
        )}
      >
        <div style={{ padding: "5px 10px 5px 10px" }}>
          <Row>
            <Col span={10} style={{ display: "flex", alignItems: "center", justifyContent: "left", color: "#0F0718", fontWeight: 500, fontSize: "1.5em", fontWeight: 600 }}>
              Current Order
            </Col>
            <Col span={14} style={{ fontSize: "1em", color: "#0F0718", fontWeight: 500, display: "flex", alignItems: "center", justifyContent: "center" }}>
              Number of Splits
              <Select
                size="small"
                defaultValue={2}
                style={{ width: 100, border: "1px solid #ccc", marginLeft: "0.5vw", borderRadius: "5px" }}
                onChange={(value) => {
                  setNumSplits(value);
                }}
              >
                {[2, 3, 4, 5, 6].map((num) => (
                  <Option key={num} value={num}>
                    {num} {"People"}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row justify="space-between" style={{ marginBottom: 12 }}>
            <Col span={12}>
              <p style={{ color: "#929098", fontSize: "1em", fontWeight: 500, marginBottom: 0 }}>
                {cart?.tableNo} - {cart?.documentno}
              </p>
            </Col>
          </Row>
          <Scrollbars autoHide style={{ height: "30vh" }}>
            <Row style={{ fontSize: "1vw" }}>
              {cart?.items?.map((item, index) => (
                <React.Fragment key={index}>
                  <Col span={12} style={{ fontSize: "1.1em", color: "#0F0718", fontWeight: 400, paddingBottom: "6px" }}>
                    {item.weight}x {item.name}
                  </Col>
                  <Col
                    span={12}
                    style={{
                      fontSize: "1.1em",
                      color: "#0F0718",
                      fontWeight: 400,
                      paddingBottom: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "right",
                      paddingRight: "10px",
                    }}
                  >
                    {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {/* {item.nettotal.toFixed(item?.isQtyDesimal)} */}
                    {toFixedTruncate(item.nettotal, item?.isQtyDesimal)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                  </Col>
                </React.Fragment>
              ))}
            </Row>
          </Scrollbars>

          <Divider style={{ margin: "12px 0" }} />
          <Row>
            <Col span={12} style={{ display: "flex", alignItems: "center", justifyContent: "left", color: "#0F0718", fontSize: "1.2em", fontWeight: 500 }}>
              Total:
            </Col>
            <Col span={12} style={{ display: "flex", alignItems: "center", justifyContent: "right", color: "#0F0718", fontSize: "1.2em", fontWeight: 500 }}>
              {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
              {/* {cart?.total.toFixed(2)} */}
              {toFixedTruncate(cart?.total + serviceChargeAmount + tipTotal + deliveryChargeAmount + packingChargeAmount, pricePrecision)}
              {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
            </Col>
          </Row>

          <Row justify="center" gutter={16} style={{ marginTop: "1.8vh" }}>
            <Col span={12}>
              <Button
                style={{ width: "100%", border: "1px solid #92909880", borderRadius: "5px", color: "#0F0718", height: "5.5vh" }}
                onClick={() => {
                  setShowSplitBill(false);
                  setIsSplitBill(false);
                  setSplitCarts([]);
                  setCurrentSplitIndex(0);
                  setSplitBillScreen(false);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col span={12}>
              <Button
                style={{ width: "100%", border: "1px solid #92909880", borderRadius: "5px", color: "#fff", backgroundColor: "#2F3856", height: "5.5vh" }}
                type="primary"
                onClick={() => {
                  const splitCarts = Array.from({ length: numSplits }, (_, i) => {
                    const splitItems = cart.items.map((item) => ({
                      ...item,
                      nettotal: Number(toFixedTruncate(item.nettotal / numSplits, item?.isQtyDesimal)),
                      total: Number(toFixedTruncate(item.total / numSplits, item?.isQtyDesimal)),
                      grosslist: Number(toFixedTruncate(item.grosslist / numSplits, item?.isQtyDesimal)),
                      linegross: Number(toFixedTruncate(item.linegross / numSplits, item?.isQtyDesimal)),
                      linenet: Number(toFixedTruncate(item.linenet / numSplits, item?.isQtyDesimal)),
                      sunitprice: Number(toFixedTruncate(item.sunitprice / numSplits, item?.isQtyDesimal)),
                    }));
                    return {
                      ...cart,
                      documentno: `${cart.documentno} - ${i + 1}`,
                      items: splitItems,
                      total: Number(toFixedTruncate(cart.total / numSplits, pricePrecision)),
                      tax: Number(toFixedTruncate(cart.tax / numSplits, pricePrecision)),
                      subTotal: Number(toFixedTruncate(cart.subTotal / numSplits, pricePrecision)),
                      serviceCharge: Number(toFixedTruncate(cart.serviceCharge / numSplits, pricePrecision)),
                      tip: Number(toFixedTruncate(cart.tip / numSplits, pricePrecision)),
                      deiveryCharge: Number(toFixedTruncate(cart.deiveryCharge / numSplits, pricePrecision)),
                      packingCharge: Number(toFixedTruncate(cart.packingCharge / numSplits, pricePrecision)),
                      tableNo: localStorage.getItem("dineIn") === "Y" ? cart.tableNo : "",
                      splitNo: i + 1,
                      isSplit: "Y",
                    };
                  });
                  setSplitCarts(splitCarts);
                  setIsSplitBill(true);
                  setCurrentSplitIndex(0);
                  // setCart(splitCarts[0]);
                  setSplitBillScreen(true);
                  setShowSplitBill(false);
                  setShowAllItems(true);
                }}
              >
                Split Bill
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
};

export default MenuLayout;
